<template>
 
   <div   style="background:#fff!important">



<div v-if='addbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-md-flex d-none justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='closeaddbox'></div>
  <div style="width:455px;position:relative;z-index:100000000;">
        
        <div style="padding:33px" class="loginwrapper">

            <form  v-on:submit.prevent='addaddress'>
              <div class="d-flex align-items-center justify-content-between">
                <p style="font-size: 18px;font-weight:700;color: #0B0A23;">Add Address</p>
                <i class='bx bx-x' style="color:#0B0A23;font-size:25px;cursor:pointer!important" v-on:click='closeaddbox'></i>
              </div>


              <div class="pt-2"> 

                  <div style="width:100%;padding-right:0px">
                  
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" placeholder="Enter Name" style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300" v-model='addrnames' name="">
                    </div>
                    
                  </div>
                   <div style="width:100%;padding-left:0px">
                    
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" placeholder="Enter Mobile Number" style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300"  v-model='addrmobile' name="">
                    </div>
                  </div>
    

                 
                  
                  <div style="width:100%;padding-right:0px">
                   
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" v-model='addrpincode' placeholder="Enter Pincode" style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300" name="">
                    </div>
                    
                  </div>
                   <div style="width:100%;padding-left:0px">
                    
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" placeholder="Enter City" v-model='addrcity' style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300" name="">
                    </div>
                  </div>
               
                  
                   <div style="width:100%;padding-left:0px">
                     
                    <div style="" class="inpbor">
                      <textarea required=""  type="text" class="form-control placeaddr" placeholder="Enter Address" v-model='addraddress' style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300;min-height:80px" name=""></textarea>
                    </div>
                  </div>
              
              </div>



 

                   

 
                              <div class="mt-4 ">

                                <button v-if='!edit'   class="btn loggrn" style=" background: #EB3838;border-radius: 5px;cursor:pointer;font-weight: bold;
font-size: 16px;
font-weight:700;
padding:10px;
width:100%;
text-align: center;

color: #FFFFFF;
 "   >Add Address</button>
                                   <button v-else class="btn loggrn" style=" background: #EB3838;border-radius: 5px;cursor:pointer;font-weight: bold;
font-size: 16px;
font-weight:700;
padding:10px;
width:100%;
text-align: center;

color: #FFFFFF;
 "  >Edit Address</button>
                              
                               
                              </div>
                              

            </form>
          
        </div>
    
  </div>


</div>









<div v-if='addbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-md-none d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='closeaddbox'></div>
  <div style="width:670px;position:relative;z-index:100000000;">
        
        <div style="padding:33px" class="loginwrapper">

            <form  v-on:submit.prevent='addaddress'>
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Add new addresssss</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='closeaddbox'></i>
              </div>


              <div class="pt-2">
                
                
                  
   
                   




                    <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="text" id="addrnames"  name="addrnames" class="logininput loginin"   required="" v-model='addrnames' minlength="10" maxlength="10">

                              <label style=" " for='addrnames' v-bind:class="{labelanims:true,defaultlabelanims:addrnames.length>0}" >Name</label>
                              <div class="bottomlines"></div>
                           
                     </div>
                      <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="number" id="addrmobile"  name="addrmobile" class="logininput loginin"   required="" v-model='addrmobile' minlength="10" maxlength="10">

                              <label style=" " for='addrmobile' v-bind:class="{labelanims:true,defaultlabelanims:addrmobile.length>0}" >Mobile Number</label>
                              <div class="bottomlines"></div>
                           
                     </div>
                      <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="text" id="addrpincode"  name="addrpincode" class="logininput loginin"   required="" v-model='addrpincode' minlength="10" maxlength="10">

                              <label style=" " for='addrpincode' v-bind:class="{labelanims:true,defaultlabelanims:addrpincode.length>0}" >Pincode</label>
                              <div class="bottomlines"></div>
                           
                     </div>

 <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="text" id="addrcity"  name="addrcity" class="logininput loginin"   required="" v-model='addrcity' minlength="10" maxlength="10">

                              <label style=" " for='addrcity' v-bind:class="{labelanims:true,defaultlabelanims:addrcity.length>0}" >City</label>
                              <div class="bottomlines"></div>
                           
                     </div>

 <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="text" id="addraddress"  name="addraddress" class="logininput loginin"   required="" v-model='addraddress' minlength="10" maxlength="10">

                              <label style=" " for='addraddress' v-bind:class="{labelanims:true,defaultlabelanims:addraddress.length>0}" >Address</label>
                              <div class="bottomlines"></div>
                           
                     </div>





 
              </div>



 

                   

 
                              <div class="d-flex align-items-center justify-content-center">

                                <button v-if='!edit'   class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#146eb4;padding:12px 20px;margin-top:30px;font-size:15px;cursor:pointer "   >Add Address</button>
                                   <button v-else class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#146eb4;padding:12px 20px;margin-top:30px;font-size:15px;cursor:pointer "   >Edit Address</button>
                              
                               
                              </div>
                              

            </form>
          
        </div>
    
  </div>


</div>






















<div v-if='apply'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='apply=false'></div>
  <div style="width:450px;position:relative;z-index:100000000;
">
        
        <div style="" class="loginwrapper">

            <form  v-on:submit.prevent='addaddress'>
              <div class="d-flex align-items-center justify-content-between mt-md-0 mt-3">
                <p style="" class="applytxt" >Apply Coupon</p>
                <i class='bx bx-x' style="color:#0B0A23;font-size:30px;cursor:pointer" v-on:click='apply=false'></i>
              </div>


              <div class="pt-2">
                
                
                
                 <div class="d-flex align-items-start mt-md-4 mt-2" style=" ">
                  
                  
                   <div style="width:100%;padding-left:0px">
                   
                    
                    <form v-on:submit.prevent='checkcoupon' style="" class="d-flex align-items-center pr-4   inpapply">
                      <div  style="flex:1">

                      
                      <input required=""  type="text" class="form-control coupinput" placeholder="Enter coupon code" v-model='coupontext' style="" name=""> 
                      </div>

                     <button v-if='coupontext.length>0' style="border:none;box-shadow:none;outline:none;font-weight: 600;font-size: 15px;color: #EB3838;cursor:pointer" >Apply</button>

                      <p  v-else style="" class="applybtn" >Apply</p>

                    </form>
                    <p v-if='notavailable' style="color:#e50b20;font-size:12px;font-weight:400;margin-top:5px">Sorry! This coupon code is not applicable.</p>

                    <div class="mt-md-5 mt-3">

                      <p style="" class="avlcoup ">Available Coupons</p>

                          <template v-for='itm in coupons' v-if='itm.showcoupon'>
                            
                         
                      <div class="mb-md-4 mb-2   " style="margin-top:30px!important">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                          <div style="border-radius: 3px;background: #FFF5E7;
border: 1px solid #FFB13B;text-transform:uppercase;padding:6px 20px;font-weight: 600;
font-size: 12px;
 

text-align: center;
letter-spacing:0.7px;
color: #F39F1F;">{{itm.couponcode}}</div>

                           <span  class="applybtn" v-on:click='applycoupon(itm)'>Apply</span>
                        </div>


                        <p class="mt-3 couptitle" style=""> ₹{{itm.discountamount}} off on all orders above ₹{{itm.minorderamount}}  </p>
                        <p style="font-weight: 500;
font-size: 13px;
 

font-family: 'Nunito', sans-serif;
color: #9A9BA7;
" class="mt-1">Applicable only  once per user</p>
                      </div>
                    </template>
                     



                    </div>
                  </div>
                </div>
              </div>



 
 
                              

            </form>
          
        </div>
    
  </div>


</div>















<div v-if='deletebox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='deletebox=false'></div>
  <div style="width:360px;position:relative;z-index:100000000;">
        
        <div style="padding:33px" class="loginwrapper">

            
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Delete this address?</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='deletebox=false'></i>
              </div>


                              <div class="d-flex align-items-center justify-content-center">

                                <button v-on:click='finaldelete'    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#E63631;padding:9px 25px;margin-top:30px;font-size:15px;cursor:pointer "  >Delete</button>
                                 
                              </div>
                              


             



 

                   

  

         
          
        </div>
    
  </div>


</div>





  
<div v-if='loginbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='loginbox=false'></div>
  <div v-if="logintype=='send'" style="width:470px;position:relative;z-index:100000000">
        
        <div style="" class="loginwrapper">

            <form  v-on:submit.prevent='login'>
              <div class="d-flex align-items-center justify-content-between mt-md-0 mt-3">
                <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">Enter Mobile Number</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>
              </div>


                            <div style="position: relative;    background: #FFFFFF!important;
    border: 1px solid #E7E5F2!important;
    border-radius: 5px;!important" class='labhead  d-flex align-items-center '  id="hideinputl">
                              <p style="padding-left:10px;color:rgb(11, 10, 35);font-weight:600" class="p91">+91 </p><span style="height:50px;width:1px;background:rgb(231 229 242 / 60%);margin:0px 15px;"></span>
                              
                              <div style="flex:1" class="d-md-block d-none">
                                
                        
                            <input autofocus=""  type="text" placeholder="Enter your mobile number" name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
                           
                                  </div>


                                     

                                      <div style="flex:1;position:relative" class="d-md-none d-block">
                                
                         
                             <input  autofocus=""  type="number" id="phonenumber" placeholder="Enter your mobile number"  name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
 
                    
                           
                                  </div>




                        





                          </div>
                              <div id="recaptcha-container"></div>

                   

 
                              <div class="d-flex align-items-center justify-content-center martp" style="" v-if='!sendotpclicked' >

                                <button    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px;font-size:15px;cursor:pointer " v-if='phone.length==10'  >Send Otp</button>
                                <button disabled=""  class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px; font-size:15px;cursor:pointer "   v-if='phone.length!=10' >Send Otp</button>
                              </div>

                               <div class="d-flex align-items-center justify-content-center martp" v-if='sendotpclicked' >

                                  <button    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px;font-size:15px;cursor:pointer "  >
                                  <img src="./images/signinloader.svg" style="width:30px">
                                </button>
                              </div>
                              

            </form>
          
        </div>
    
  </div>











  <div v-if="logintype=='otp'" style="width:500px;position:relative;z-index:100000000">
        
        <div  class="loginwrapper">

            

              <div class="d-flex align-items-center justify-content-between  mar40"  >

                 <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">OTP Verification</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>



               
              </div>

                      
       

            <div  class="otpboxes  " style="">
    <v-otp-input
      inputClasses="otp-input"
      :numInputs="6"
       separator=""
      :shouldAutoFocus="true"
                        

                     @on-complete="subotp"
       
    />
  </div>
                           

                     
 

<div class="d-flex align-items-center justify-content-center">
  

      <button   class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px; font-size:15px;cursor:pointer " v-on:click='subotps'   v-if='otpenterd' >Login</button>
      </div>
 

  <p v-if='perrs' style="text-align:center;color:red">{{otptext}}</p>
 
                              

       
          
        </div>
    
  </div>




</div>





<!--
 
  
   <div v-if='!loadstatus' style="z-index:100000000000000;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.3)" class="d-flex align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://shop.websitelearners.com/static/img/loader.0395a07.gif" class="img-fluid" style="width:100%">
   </div>
 </div>

-->


 
   <div v-if='orderplaced' style="z-index:100000000000000;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.3)" class="d-flex align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://shop.websitelearners.com/static/img/loader.0395a07.gif" class="img-fluid" style="width:100%">
   </div>
 </div>





  <div  >
 
<div    style="" class="heads"> 





<div style="z-index: 10000;position: fixed;bottom: 0;left: 0;right: 0;padding:10px 27px;background: #fff;" class="d-md-none d-flex align-items-center justify-content-between">


  






  <div  >


    <router-link to="/" style='text-decoration:none'>

 <img src="./images/files/homeblack.svg" style="transform:translateY(-1px)" >



</router-link>
</div>


 
 





   <div  class="botactive navclass"   style="position:relative">
    <router-link to="/bag" style='text-decoration:none'>

<div style="width:16px;height:16px;background:#fff;border-radius:50%; z-index:10000;   position: absolute;
    top: 3px;
    right: 4px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#EB3838;font-size:10px;font-weight:700">{{rendercartlength}}</span>
</div>
 <img src="./images/files/bagwhite.svg"  style="width:20px;transform:translateY(-1px)" >

  </router-link>
  </div>




   <div v-bind:class="[{ botactive:$route.path=='/'+$route.path.split('/')[1]+'/account'  },{ botnotactive: !($route.path=='/account') },{navclass:true}]" v-on:click='account'>
        

 <img src="./images/files/user.svg" style="width:20px;transform:translateY(-1px)"   >
 
  </div>
   
</div>





 


<!-- heaaderr -->



 

  </div>
  
</div>






   

<div  class="  pt-md-4 pb-md-4 pt-3 pb-3  headerwrapper" style="position:sticky;top:0px;background:#fff;z-index:10000000">
  <div class="container  ">

  <div class="headerui     ">
    <router-link  to="/" style='text-decoration:none'>
<div class="d-flex align-items-center mr-4  logowrapper">
  
  <img src="./images/finallogo.png" style="" class="logohigh">
</div>
</router-link>
 






<div class="d-flex align-items-center  navwrapper  ml-3   ">
  

  <div class="d-none align-items-center contactwhatsapp" style="">
    
    <img src="https://cdn.usbrandcolors.com/images/logos/whatsapp-logo.svg" style="width:20px;margin-right:6px;min-width:20px;">

 <p style="font-weight:600;color:#fff;font-size:13px">WhatsApp</p>

  </div>


 
  <router-link    to="/bag"  style='text-decoration:none'>
  <div class="d-flex align-items-center navitem pl-4 ml-4" style="position:relative;margin-left:30px">
    
          <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>


    <div style="width:16px;height:16px;background:#EB3838;border-radius:50%;    position: absolute;
    top: 2px;
    right: 10px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:11px;font-weight:600">{{rendercartlength}}</span>
</div>



 <svg width="17" height="20" viewBox="0 0 17 20" fill="#0B0A23" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.7" d="M15 5.83333H11.6667V3.33333C11.6667 1.4925 10.1742 0 8.33333 0C6.4925 0 5 1.4925 5 3.33333V5.83333H1.66667L0 20H16.6667L15 5.83333ZM5.83333 3.33333C5.83333 1.955 6.955 0.833333 8.33333 0.833333C9.71167 0.833333 10.8333 1.955 10.8333 3.33333V5.83333H5.83333V3.33333ZM5 7.5V8.75C5 8.98 5.18667 9.16667 5.41667 9.16667C5.64667 9.16667 5.83333 8.98 5.83333 8.75V7.5H10.8333V8.75C10.8333 8.98 11.02 9.16667 11.25 9.16667C11.48 9.16667 11.6667 8.98 11.6667 8.75V7.5H13.5183L13.9108 10.8333H2.75667L3.14917 7.5H5Z" fill="#0B0A23"/>
</svg>

 


  </div>
</router-link>


   <div class="d-flex align-items-center    " style="position:relative;padding-left:50px"  >
      
      <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>

      <p class="mya" style="color: #0B0A23;

opacity: 0.8;font-weight: 500;
font-size: 14px;" v-on:click='account'>My Account</p>

<div v-if='user' style="position:absolute;top:0px;left:50%;transform:translateX(-50%);padding-top:40px;cursor:pointer" class="opanav">


  <div style="width:170px;background:#fff;border-radius:4px;box-shadow:0 0 10px rgba(0,0,0,0.1)">

    <router-link to='/whishlist' style='text-decoration:none'>
    <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Wishlist</p>
  </router-link>
   <router-link to='/account' style='text-decoration:none'>
       <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Account</p>
     </router-link>
          <p class="navhover"   v-on:click='logout' style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Logout</p>
  </div>
</div>


  </div>






</div>

</div>

  </div>
  
</div>






 




<!--- header -->





<div v-if='filterbox' style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:10000000000" class="d-flex  filterbox">
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3);z-index:100000" v-on:click='filterbox=false'></div>
  <div style="" class="actfilterbox">


     <div class="d-flex align-items-center justify-content-between mb-4">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Filter</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='filterbox=false'  ></i>
              </div>

    <template v-for='itm in filters'>
      <div class="d-flex align-items-center my-3" style="cursor:pointer" v-on:click='filterorder(itm)'>
        <div style="width:19px;height:19px;position:relative;border-radius:50px;border:1px solid #00988b">
          <div style="position:absolute;top:3px;right:3px;bottom:3px;left:3px;border-radius:50px;background:#00988b" v-if='itm.selected'></div>
        </div>
        <p style="margin-left:8px;color:#444;font-size:16px">{{itm.name}}</p>
      </div>
    </template>
    
  </div>
</div>

<!-- filters -->
 



 

<div  v-if='loadstatus && theme==3' >

</div>


<div  v-else-if='loadstatus && theme==2' >






 

</div>



<div v-else-if='loadstatus && theme==1' >


 

 <div v-if='!(cartscomp.length>0)'   class="pt-md-4 pb-md-5   pb-3      " style="height:90vh;">
  <div   style="padding:0px;margin:0px;height:100% ">
    <div class="container pads" style="padding:0px">
          <p style=""    class="mt-md-5 mb-md-5 mb-3 mt-md-3 mt-0 shopbag">Whishlist</p>

    </div>


    <div class="d-flex align-items-center justify-content-center contentheight" style="">
      <div  style="max-width:500px">
        <div style="text-align:center">
               

               <svg class='emptybag' width="250" height="209" viewBox="0 0 250 209" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0)">
<path opacity="0.1" d="M81.0426 7.42281C88.3528 0.915976 99.8273 -0.417925 110.273 0.100119C143.08 1.73183 172.694 17.5685 198.311 35.4848C207.585 41.9691 216.715 48.9589 222.734 57.8908C234.997 76.0724 231.353 101.259 214.315 116.237C208.516 121.332 201.489 125.247 194.274 128.703C181.446 134.859 167.603 139.802 153.043 141.216C142.662 142.217 132.151 141.404 121.828 140.005C92.9901 136.085 64.6879 127.436 40.9555 112.641C30.5496 106.152 20.7418 98.083 16.4523 87.5895C12.1628 77.096 14.9082 63.782 25.5343 57.558C29.9289 54.9878 35.1844 53.8265 40.3273 52.7354C47.9003 51.1312 55.5934 49.5496 62.4255 46.2886C69.4855 42.9201 77.8417 36.4058 76.4403 28.9479C74.9487 20.957 73.7424 13.9296 81.0426 7.42281Z" fill="#EB3838"/>
<path d="M171.417 167.398C171.417 167.398 177.689 156.289 187.131 153.088C191.101 151.771 194.536 149.201 196.922 145.766C198.042 144.126 199.008 142.387 199.81 140.57" stroke="#535461" stroke-width="2" stroke-miterlimit="10"/>
<path d="M205.751 138.515C204.675 139.561 199.662 140.64 199.662 140.64C199.662 140.64 200.891 135.662 201.967 134.619C202.484 134.117 203.179 133.841 203.899 133.852C204.619 133.862 205.306 134.158 205.807 134.675C206.309 135.192 206.585 135.887 206.574 136.607C206.564 137.327 206.268 138.014 205.751 138.515Z" fill="#EB3838"/>
<path d="M202.915 147.522C201.444 147.815 196.659 145.998 196.659 145.998C196.659 145.998 200.398 142.495 201.867 142.194C202.573 142.054 203.307 142.2 203.906 142.6C204.505 143.001 204.92 143.622 205.06 144.329C205.201 145.036 205.055 145.769 204.654 146.368C204.254 146.967 203.632 147.382 202.926 147.522H202.915Z" fill="#EB3838"/>
<path d="M192.592 157.268C191.173 156.767 187.952 152.788 187.952 152.788C187.952 152.788 192.958 151.647 194.369 152.137C194.713 152.248 195.032 152.426 195.306 152.662C195.581 152.898 195.805 153.186 195.967 153.509C196.128 153.833 196.223 154.185 196.247 154.546C196.27 154.907 196.221 155.269 196.103 155.611C195.985 155.952 195.799 156.267 195.558 156.536C195.316 156.805 195.023 157.023 194.696 157.178C194.369 157.332 194.015 157.42 193.653 157.435C193.292 157.45 192.931 157.394 192.592 157.268Z" fill="#EB3838"/>
<path d="M183.12 162.884C181.641 162.633 177.792 159.252 177.792 159.252C177.792 159.252 182.524 157.28 184.003 157.525C184.358 157.58 184.698 157.705 185.004 157.892C185.31 158.08 185.575 158.326 185.786 158.616C185.996 158.907 186.147 159.236 186.229 159.585C186.312 159.934 186.324 160.296 186.266 160.65C186.207 161.004 186.079 161.343 185.889 161.647C185.699 161.952 185.451 162.215 185.158 162.423C184.866 162.63 184.535 162.778 184.185 162.857C183.835 162.936 183.473 162.945 183.12 162.884Z" fill="#EB3838"/>
<path d="M192.47 142.109C192.47 143.611 195.182 147.958 195.182 147.958C195.182 147.958 197.9 143.611 197.9 142.112C197.9 141.392 197.614 140.701 197.105 140.192C196.596 139.682 195.905 139.396 195.185 139.396C194.465 139.396 193.774 139.682 193.265 140.192C192.756 140.701 192.47 141.392 192.47 142.112V142.109Z" fill="#EB3838"/>
<path d="M181.476 148.816C181.926 150.248 185.815 153.586 185.815 153.586C185.815 153.586 187.107 148.623 186.659 147.192C186.443 146.505 185.964 145.931 185.325 145.597C184.687 145.264 183.942 145.197 183.255 145.413C182.568 145.628 181.994 146.108 181.66 146.746C181.327 147.384 181.26 148.129 181.476 148.816Z" fill="#EB3838"/>
<path d="M171.685 156.8C171.885 158.286 175.156 162.235 175.156 162.235C175.156 162.235 177.269 157.563 177.068 156.076C176.972 155.362 176.597 154.716 176.024 154.279C175.452 153.842 174.729 153.65 174.015 153.746C173.301 153.842 172.655 154.218 172.218 154.79C171.781 155.363 171.589 156.086 171.685 156.8Z" fill="#EB3838"/>
<path opacity="0.25" d="M205.751 138.515C204.675 139.561 199.662 140.64 199.662 140.64C199.662 140.64 200.891 135.662 201.967 134.619C202.484 134.117 203.179 133.841 203.899 133.852C204.619 133.862 205.306 134.158 205.807 134.675C206.309 135.192 206.585 135.887 206.574 136.607C206.564 137.327 206.268 138.014 205.751 138.515Z" fill="black"/>
<path opacity="0.25" d="M202.915 147.522C201.444 147.815 196.659 145.998 196.659 145.998C196.659 145.998 200.398 142.495 201.867 142.194C202.573 142.054 203.307 142.2 203.906 142.6C204.505 143.001 204.92 143.622 205.06 144.329C205.201 145.036 205.055 145.769 204.654 146.368C204.254 146.967 203.632 147.382 202.926 147.522H202.915Z" fill="black"/>
<path opacity="0.25" d="M192.592 157.268C191.173 156.767 187.952 152.788 187.952 152.788C187.952 152.788 192.958 151.647 194.369 152.137C194.713 152.248 195.032 152.426 195.306 152.662C195.581 152.898 195.805 153.186 195.967 153.509C196.128 153.833 196.223 154.185 196.247 154.546C196.27 154.907 196.221 155.269 196.103 155.611C195.985 155.952 195.799 156.267 195.558 156.536C195.316 156.805 195.023 157.023 194.696 157.178C194.369 157.332 194.015 157.42 193.653 157.435C193.292 157.45 192.931 157.394 192.592 157.268Z" fill="black"/>
<path opacity="0.25" d="M183.12 162.884C181.641 162.633 177.792 159.252 177.792 159.252C177.792 159.252 182.524 157.28 184.003 157.525C184.358 157.58 184.698 157.705 185.004 157.892C185.31 158.08 185.575 158.326 185.786 158.616C185.996 158.907 186.147 159.236 186.229 159.585C186.312 159.934 186.324 160.296 186.266 160.65C186.207 161.004 186.079 161.343 185.889 161.647C185.699 161.952 185.451 162.215 185.158 162.423C184.866 162.63 184.535 162.778 184.185 162.857C183.835 162.936 183.473 162.945 183.12 162.884Z" fill="black"/>
<path opacity="0.25" d="M192.47 142.109C192.47 143.611 195.182 147.958 195.182 147.958C195.182 147.958 197.9 143.611 197.9 142.112C197.9 141.392 197.614 140.701 197.105 140.192C196.596 139.682 195.905 139.396 195.185 139.396C194.465 139.396 193.774 139.682 193.265 140.192C192.756 140.701 192.47 141.392 192.47 142.112V142.109Z" fill="black"/>
<path opacity="0.25" d="M181.476 148.816C181.926 150.248 185.815 153.586 185.815 153.586C185.815 153.586 187.107 148.623 186.659 147.192C186.443 146.505 185.964 145.931 185.325 145.597C184.687 145.264 183.942 145.197 183.255 145.413C182.568 145.628 181.994 146.108 181.66 146.746C181.327 147.384 181.26 148.129 181.476 148.816Z" fill="black"/>
<path opacity="0.25" d="M171.685 156.8C171.885 158.286 175.156 162.235 175.156 162.235C175.156 162.235 177.269 157.563 177.068 156.076C176.972 155.362 176.597 154.716 176.024 154.279C175.452 153.842 174.729 153.65 174.015 153.746C173.301 153.842 172.655 154.218 172.218 154.79C171.781 155.363 171.589 156.086 171.685 156.8Z" fill="black"/>
<path d="M171.778 167.173C171.778 167.173 173.009 154.475 180.347 147.723C183.442 144.909 185.541 141.167 186.328 137.059C186.688 135.105 186.868 133.122 186.864 131.135" stroke="#535461" stroke-width="2" stroke-miterlimit="10"/>
<path d="M191.461 126.861C190.9 128.252 186.756 131.27 186.756 131.27C186.756 131.27 185.865 126.22 186.426 124.831C186.553 124.492 186.746 124.181 186.995 123.918C187.244 123.654 187.543 123.443 187.875 123.297C188.206 123.151 188.564 123.073 188.926 123.067C189.288 123.061 189.648 123.128 189.984 123.264C190.32 123.399 190.626 123.6 190.883 123.856C191.14 124.111 191.344 124.416 191.481 124.751C191.619 125.086 191.688 125.445 191.684 125.808C191.681 126.17 191.605 126.528 191.461 126.861Z" fill="#EB3838"/>
<path d="M192.52 136.243C191.293 137.106 186.173 137.387 186.173 137.387C186.173 137.387 188.175 132.664 189.394 131.801C189.686 131.596 190.015 131.45 190.363 131.372C190.711 131.294 191.071 131.285 191.422 131.346C191.774 131.407 192.109 131.537 192.411 131.728C192.712 131.919 192.973 132.167 193.178 132.459C193.383 132.751 193.529 133.08 193.607 133.428C193.685 133.776 193.694 134.136 193.632 134.487C193.571 134.839 193.442 135.175 193.251 135.476C193.06 135.777 192.811 136.038 192.52 136.243Z" fill="#EB3838"/>
<path d="M187.031 149.337C185.53 149.462 180.975 147.119 180.975 147.119C180.975 147.119 185.082 144.051 186.566 143.924C187.284 143.863 187.996 144.09 188.546 144.555C189.097 145.02 189.44 145.685 189.5 146.402C189.561 147.12 189.333 147.833 188.868 148.383C188.404 148.933 187.739 149.276 187.021 149.337H187.031Z" fill="#EB3838"/>
<path d="M180.647 158.309C179.196 158.684 174.305 157.147 174.305 157.147C174.305 157.147 177.832 153.426 179.283 153.051C179.631 152.953 179.995 152.926 180.353 152.97C180.711 153.015 181.057 153.13 181.37 153.31C181.683 153.49 181.958 153.731 182.177 154.018C182.396 154.305 182.555 154.633 182.646 154.983C182.737 155.332 182.757 155.696 182.705 156.054C182.653 156.411 182.531 156.755 182.345 157.064C182.158 157.374 181.912 157.643 181.621 157.856C181.329 158.07 180.998 158.222 180.647 158.306V158.309Z" fill="#EB3838"/>
<path d="M180.777 135.525C181.383 136.896 185.627 139.779 185.627 139.779C185.627 139.779 186.351 134.704 185.742 133.332C185.442 132.688 184.901 132.187 184.235 131.937C183.57 131.687 182.833 131.708 182.182 131.996C181.532 132.284 181.021 132.815 180.758 133.476C180.495 134.137 180.502 134.874 180.777 135.53V135.525Z" fill="#EB3838"/>
<path d="M173.445 146.113C174.433 147.24 179.343 148.716 179.343 148.716C179.343 148.716 178.515 143.656 177.524 142.53C177.291 142.255 177.005 142.029 176.684 141.866C176.362 141.703 176.012 141.605 175.652 141.579C175.292 141.552 174.931 141.598 174.59 141.712C174.248 141.827 173.932 142.009 173.661 142.247C173.391 142.485 173.17 142.774 173.012 143.098C172.854 143.422 172.763 143.775 172.743 144.135C172.722 144.495 172.774 144.855 172.895 145.195C173.015 145.534 173.202 145.847 173.445 146.113Z" fill="#EB3838"/>
<path d="M167.729 157.38C168.514 158.659 173.104 160.941 173.104 160.941C173.104 160.941 173.142 155.816 172.353 154.537C172.167 154.233 171.922 153.969 171.633 153.76C171.345 153.551 171.018 153.4 170.671 153.318C170.324 153.235 169.964 153.221 169.612 153.277C169.26 153.333 168.922 153.458 168.618 153.645C168.314 153.832 168.05 154.076 167.841 154.365C167.632 154.654 167.481 154.981 167.399 155.328C167.316 155.675 167.302 156.034 167.358 156.387C167.414 156.739 167.539 157.076 167.726 157.38H167.729Z" fill="#EB3838"/>
<path opacity="0.1" d="M93.6408 208.714C110.072 208.714 123.392 206.481 123.392 203.726C123.392 200.972 110.072 198.739 93.6408 198.739C77.2097 198.739 63.8896 200.972 63.8896 203.726C63.8896 206.481 77.2097 208.714 93.6408 208.714Z" fill="#EB3838"/>
<path opacity="0.1" d="M152.2 170.426C168.631 170.426 181.951 168.193 181.951 165.439C181.951 162.684 168.631 160.451 152.2 160.451C135.769 160.451 122.449 162.684 122.449 165.439C122.449 168.193 135.769 170.426 152.2 170.426Z" fill="#EB3838"/>
<path d="M154.174 99.6121L154.147 100.586L152.455 160.278H149.612L151.006 100.586L151.034 99.4619L154.174 99.6121Z" fill="#B77B7F"/>
<path d="M170.634 150.18L168.504 150.175L136.861 150.108L135.174 150.105L136.073 147.337H170.409L170.634 150.18Z" fill="#DDA2A6"/>
<path opacity="0.1" d="M154.174 99.6121L154.147 100.586H151.006L151.034 99.4619L154.174 99.6121Z" fill="black"/>
<path d="M155.373 98.1531H150.1V100.138H155.373V98.1531Z" fill="#B77B7F"/>
<path opacity="0.1" d="M137.142 147.337L136.861 150.108L135.174 150.105L136.073 147.337H137.142Z" fill="black"/>
<path d="M141.684 98.1155L141.596 98.9764L134.576 168.209L131.36 168.056L138.758 98.9764L138.841 98.1906L141.684 98.1155Z" fill="#DDA2A6"/>
<path opacity="0.1" d="M170.634 150.18L168.504 150.175L168.217 147.337H170.409L170.634 150.18Z" fill="black"/>
<path d="M174 168.056L170.782 168.209L163.764 98.9764L163.677 98.1155L166.517 98.1906L166.6 98.9764L174 168.056Z" fill="#DDA2A6"/>
<path d="M187.687 29.8563H116.773V97.8527H187.687V29.8563Z" fill="white"/>
<path d="M153.614 7.11491V23.5347H150.848V7.11491C150.84 6.92838 150.87 6.74218 150.936 6.5675C151.002 6.39282 151.103 6.23329 151.232 6.0985C151.361 5.96371 151.516 5.85645 151.688 5.78317C151.86 5.70989 152.044 5.67212 152.231 5.67212C152.418 5.67212 152.603 5.70989 152.774 5.78317C152.946 5.85645 153.101 5.96371 153.23 6.0985C153.359 6.23329 153.46 6.39282 153.526 6.5675C153.592 6.74218 153.622 6.92838 153.614 7.11491Z" fill="#DDA2A6"/>
<path opacity="0.1" d="M153.614 22.0406H150.846V23.5347H153.614V22.0406Z" fill="black"/>
<path d="M154.7 23.1619V28.5825H149.777V23.1619C149.777 23.0734 149.794 22.9857 149.828 22.9038C149.862 22.822 149.911 22.7477 149.974 22.6851C150.036 22.6225 150.111 22.5729 150.192 22.5392C150.274 22.5055 150.362 22.4883 150.45 22.4887H154.032C154.209 22.49 154.379 22.5615 154.504 22.6876C154.63 22.8137 154.7 22.9842 154.7 23.1619Z" fill="#DDA2A6"/>
<path opacity="0.1" d="M152.23 26.9759C152.808 26.9759 153.276 26.5075 153.276 25.9298C153.276 25.352 152.808 24.8837 152.23 24.8837C151.652 24.8837 151.184 25.352 151.184 25.9298C151.184 26.5075 151.652 26.9759 152.23 26.9759Z" fill="black"/>
<path d="M152.23 26.7505C152.808 26.7505 153.276 26.2822 153.276 25.7044C153.276 25.1267 152.808 24.6583 152.23 24.6583C151.652 24.6583 151.184 25.1267 151.184 25.7044C151.184 26.2822 151.652 26.7505 152.23 26.7505Z" fill="#B77B7F"/>
<path opacity="0.1" d="M154.7 27.9117H149.762V28.5849H154.7V27.9117Z" fill="black"/>
<path opacity="0.1" d="M156.72 28.8103H147.743V30.3069H156.72V28.8103Z" fill="black"/>
<path d="M156.72 28.3597H147.743V29.8563H156.72V28.3597Z" fill="#DDA2A6"/>
<path opacity="0.1" d="M134.071 96.101H171.773C172.204 96.101 172.618 96.2723 172.923 96.5774C173.228 96.8825 173.4 97.2962 173.4 97.7277V98.083H132.444V97.7277C132.444 97.2962 132.615 96.8825 132.921 96.5774C133.226 96.2723 133.639 96.101 134.071 96.101Z" fill="black"/>
<path opacity="0.1" d="M138.841 98.1906L141.684 98.1155L141.596 98.9764H138.758L138.841 98.1906Z" fill="black"/>
<path opacity="0.1" d="M155.373 98.1531H150.1V98.9764H155.373V98.1531Z" fill="black"/>
<path opacity="0.1" d="M166.6 98.9764H163.764L163.677 98.1155L166.517 98.1906L166.6 98.9764Z" fill="black"/>
<path d="M134.071 96.5438H171.773C172.204 96.5438 172.618 96.7152 172.923 97.0203C173.228 97.3253 173.4 97.7391 173.4 98.1705V98.5259H132.444V98.1705C132.444 97.7391 132.615 97.3253 132.921 97.0203C133.226 96.7152 133.639 96.5438 134.071 96.5438Z" fill="#DDA2A6"/>
<path d="M125.805 64.9758C125.237 64.6754 119.048 60.0005 119.048 60.0005L109.06 53.6664C109.06 53.6664 109.007 53.5162 108.912 53.2585C111.652 50.1477 111.054 45.6329 108.266 42.4596C104.888 38.6106 89.6216 30.3244 85.0218 37.4118C84.3786 38.4129 84.3561 39.5491 84.1884 40.6502C83.7955 43.2204 82.5292 45.7105 80.5421 47.8077C79.0105 49.4269 77.0008 50.9185 76.1199 52.7504C76.1199 52.7279 76.1024 52.7054 76.0949 52.6803C75.8822 53.073 75.728 53.4945 75.6369 53.9317C75.199 56.1665 76.7005 58.3088 77.4989 60.4835C77.7668 61.22 77.9613 61.9812 78.0795 62.7559C78.0995 62.6008 78.117 62.4481 78.1345 62.2929C78.3291 63.3961 78.3954 64.5181 78.3322 65.6365C72.7889 66.7651 72.7864 76.2476 72.7864 76.2476C72.7864 76.2476 72.1032 80.0166 72.2183 81.3755C72.3334 82.7344 72.3309 85.6725 72.3309 86.3807C72.3309 87.089 71.6477 91.5061 71.5802 92.0367C71.5808 92.0442 71.5808 92.0517 71.5802 92.0592C71.4801 92.6398 70.4415 95.4377 72.9516 96.0634C73.1268 96.1084 73.312 96.146 73.5047 96.181C73.6123 98.4459 73.8075 103.188 73.6348 104.244C73.6348 104.244 74.5483 110.616 75.3066 112.235C75.7861 113.185 76.3471 114.091 76.9833 114.943C76.9283 115.331 76.7973 115.705 76.5979 116.042C76.21 116.6 76.4102 117.058 77.0584 117.256C77.0359 117.448 77.0109 117.666 76.9833 117.911C76.7055 120.369 76.2901 125.254 76.9958 127.729C77.9644 131.123 78.0219 132.254 78.0219 132.254C78.0219 132.254 78.0219 133.27 78.4223 133.836C78.8228 134.401 79.561 139.662 79.561 140.51C79.561 141.358 81.4981 148.991 80.9275 150.801C80.3569 152.61 80.8149 155.155 80.8149 155.155C80.8149 155.155 80.472 159.623 80.0641 160.584C79.6561 161.545 79.4935 177.038 80.1191 181.053C80.7448 185.067 81.1452 188.403 81.1452 188.403C81.1452 188.403 80.7473 192.079 81.0876 192.587C81.428 193.095 82.0562 196.151 81.6007 196.319C81.1452 196.486 80.9175 197.733 80.9175 197.733C81.1583 198.099 81.4181 198.452 81.6958 198.791C81.5202 198.73 81.3488 198.657 81.1827 198.574C81.3629 198.824 81.6332 199.179 81.9661 199.575L81.6532 203.641C81.6401 203.8 81.683 203.958 81.7744 204.089C81.8659 204.219 82.0001 204.313 82.1538 204.355C83.1531 204.626 84.2074 204.622 85.2043 204.341C86.2012 204.061 87.1034 203.516 87.8147 202.763C90.6627 199.88 91.6312 200.275 92.1442 198.523C92.1993 198.336 92.2469 198.151 92.2869 197.975C92.6548 196.414 90.9905 195.253 89.6666 195.918C89.8493 194.682 89.992 193.278 89.8543 192.485C89.569 190.845 89.6266 186.548 89.6266 186.548L89.2287 165.964C89.2287 165.964 89.967 161.893 90.8229 160.311C91.6788 158.729 91.5736 153.186 91.5736 153.186L92.5422 134.977L93.4531 126.1C93.4531 126.1 94.3641 123.047 95.5028 126.44C95.5028 126.44 94.8771 133.28 95.1624 134.922C95.4477 136.563 95.8456 144.534 95.5603 146.286C95.275 148.038 94.0237 157.653 94.8095 160.083C95.5954 162.513 96.4713 165.459 96.2961 166.422C96.1209 167.386 95.5453 188.248 95.5453 188.248C95.5453 188.248 97.0844 192.252 95.9457 193.563C94.807 194.875 95.8882 200.07 95.8882 200.07C95.8882 200.07 96.0258 200.168 96.2611 200.303L96.2285 200.736L95.8707 205.413C95.8579 205.572 95.9009 205.73 95.9922 205.861C96.0836 205.992 96.2176 206.086 96.3712 206.129C97.3705 206.401 98.4248 206.396 99.4218 206.116C100.419 205.836 101.321 205.29 102.032 204.537C104.88 201.652 105.849 202.05 106.362 200.295C106.417 200.108 106.464 199.925 106.507 199.747C106.907 198.043 104.88 196.807 103.524 197.92L103.456 197.978C103.385 198.038 103.311 198.094 103.233 198.146C103.197 198.172 103.16 198.196 103.121 198.218C103.406 196.927 103.822 194.714 103.621 193.678C103.336 192.152 103.904 187.517 103.904 187.517C103.904 187.517 105.556 181.974 105.613 179.759L106.069 162.118C106.069 162.118 106.014 154.935 106.242 153.183C106.469 151.432 108.291 136.276 110.113 131.751C111.512 128.287 112.138 119.448 111.767 114.966C111.747 114.746 111.727 114.533 111.702 114.335C113.937 112.686 114.16 109.943 114.16 109.943C114.16 109.943 112.108 106.024 110.133 104.365C108.159 102.705 107.733 99.8524 107.803 98.6386C107.837 97.899 107.593 97.1735 107.12 96.604C107.12 96.604 106.209 93.6634 105.601 93.3631C105.551 93.3377 105.506 93.3039 105.468 93.263C105.055 92.82 105.373 91.5537 105.373 91.5537V91.5136C105.446 91.2208 105.874 89.3238 105.746 88.8383C105.593 88.3128 105.821 85.8227 105.821 85.8227C105.821 85.8227 107.265 81.5256 107.037 78.1321C106.81 74.7385 110 75.0413 110 75.0413L119.853 74.9387H120.975C121.37 74.603 121.731 74.2291 122.053 73.8225C123.93 73.5998 127.727 72.8916 128.152 70.8194C128.73 68.069 126.375 65.2786 125.805 64.9758ZM80.1567 96.3487L80.2242 94.6244C80.457 94.8246 80.6121 94.9522 80.6121 94.9522C80.7378 95.4034 80.7438 95.8795 80.6297 96.3337C80.5685 96.547 80.4601 96.7438 80.3123 96.9093C80.1645 97.0748 79.9813 97.2049 79.7763 97.2897C79.7286 97.3104 79.6826 97.3347 79.6386 97.3623L79.5435 96.3887L80.1567 96.3487ZM115.894 66.0669C115.476 65.8792 114.07 65.9167 113.347 65.9167C112.623 65.9167 111.45 65.3136 111.45 65.3136C111.199 64.8256 109.815 64.5353 108.584 64.3701C107.648 62.0627 106.332 59.8128 106.154 57.4078C106.154 57.3202 106.154 57.2326 106.141 57.145L106.284 57.3953C106.284 57.3953 112.02 61.0541 112.666 62.1503C113.166 62.9862 115.576 64.8531 116.693 65.689C116.539 65.8895 116.323 66.0338 116.079 66.0994C116.016 66.1063 115.952 66.0951 115.894 66.0669Z" fill="url(#paint0_linear)"/>
<path d="M106.422 199.762C106.379 199.937 106.334 200.12 106.279 200.305C105.778 202.057 104.82 201.652 102.025 204.512C101.328 205.259 100.441 205.801 99.4583 206.08C98.476 206.358 97.4361 206.363 96.4512 206.094C96.2975 206.053 96.163 205.96 96.0715 205.83C95.9799 205.7 95.9372 205.542 95.9507 205.383L96.3036 200.743L96.4712 198.511C96.4712 198.511 100.936 199.762 103.208 198.173C103.285 198.121 103.358 198.065 103.429 198.005C103.446 197.99 103.463 197.973 103.479 197.955C103.772 197.713 104.134 197.568 104.514 197.541C104.893 197.514 105.272 197.607 105.597 197.806C105.921 198.005 106.175 198.301 106.323 198.652C106.471 199.002 106.505 199.391 106.422 199.762Z" fill="#67647E"/>
<path d="M92.407 198.01C92.3645 198.186 92.3194 198.368 92.2644 198.553C91.7639 200.305 90.8054 199.9 88.0099 202.76C87.3134 203.507 86.4259 204.049 85.4436 204.328C84.4613 204.607 83.4215 204.612 82.4366 204.342C82.2829 204.301 82.1484 204.208 82.0568 204.078C81.9653 203.948 81.9225 203.79 81.936 203.631L82.2889 198.991L82.4566 196.759C82.4566 196.759 86.9213 198.01 89.1937 196.421C89.2699 196.369 89.3434 196.313 89.4139 196.254C89.4314 196.238 89.4481 196.221 89.4639 196.204C89.7572 195.961 90.1191 195.816 90.499 195.789C90.8788 195.762 91.2574 195.855 91.5819 196.054C91.9064 196.253 92.1604 196.549 92.3084 196.9C92.4563 197.251 92.4908 197.639 92.407 198.01Z" fill="#67647E"/>
<path opacity="0.1" d="M87.7947 198.706L87.9748 201.119C85.4122 203.679 82.3615 199.867 81.468 198.616C83.818 199.827 87.7947 198.706 87.7947 198.706Z" fill="black"/>
<path opacity="0.1" d="M102.858 199.687L103.193 199.464C100.853 203.023 97.3772 201.381 96.2936 200.743L96.4613 198.511C96.4613 198.511 100.926 199.762 103.198 198.173C103.021 199.044 102.858 199.687 102.858 199.687Z" fill="black"/>
<path d="M109.985 132.309C108.189 136.796 106.394 151.829 106.169 153.581C105.944 155.333 106.001 162.446 106.001 162.446L105.551 179.936C105.493 182.126 103.867 187.624 103.867 187.624C103.867 187.624 103.306 192.224 103.586 193.738C103.867 195.253 102.858 199.244 102.858 199.244L103.193 199.019C100.388 203.273 95.9558 200.085 95.9558 200.085C95.9558 200.085 94.8896 194.925 96.0133 193.633C97.137 192.342 95.6204 188.36 95.6204 188.36C95.6204 188.36 96.181 167.659 96.3487 166.705C96.5164 165.752 95.6755 162.833 94.8896 160.421C94.1038 158.008 95.3401 148.471 95.6204 146.732C95.9007 144.992 95.5078 137.081 95.2275 135.455C94.9472 133.828 95.5628 127.038 95.5628 127.038C94.4417 123.672 93.5432 126.703 93.5432 126.703L92.6448 135.51L91.6913 153.576C91.6913 153.576 91.8039 159.082 90.963 160.646C90.1221 162.21 89.3914 166.255 89.3914 166.255L89.7843 186.679C89.7843 186.679 89.7292 190.933 90.0095 192.567C90.2898 194.201 89.3914 198.403 89.3914 198.403C86.2506 205.804 81.2053 197.78 81.2053 197.78C81.2053 197.78 81.4305 196.546 81.8785 196.379C82.3265 196.211 81.7108 193.18 81.378 192.675C81.0451 192.169 81.433 188.523 81.433 188.523C81.433 188.523 81.0401 185.214 80.432 181.23C79.8238 177.246 79.984 161.875 80.3769 160.921C80.7698 159.968 81.1052 155.536 81.1052 155.536C81.1052 155.536 80.6572 153.011 81.2178 151.214C81.7784 149.417 79.8714 141.846 79.8714 141.003C79.8714 140.16 79.1431 134.944 78.7502 134.384C78.3573 133.823 78.3573 132.812 78.3573 132.812C78.3573 132.812 78.3022 131.691 77.3562 128.325C76.6605 125.867 77.0709 121.022 77.3437 118.582C77.4413 117.679 77.5264 117.103 77.5264 117.103C77.5264 117.103 109.703 111.885 110.987 113.064C111.287 113.342 111.487 114.295 111.605 115.654C111.988 120.099 111.357 128.883 109.985 132.309Z" fill="#444053"/>
<path opacity="0.1" d="M97.8077 157.535C97.9579 157.535 101.512 157.836 102.813 157.573C104.114 157.31 97.8077 157.535 97.8077 157.535Z" fill="black"/>
<path opacity="0.1" d="M98.0704 159.63C98.0704 159.63 102.978 160.491 103.228 160.043C103.479 159.595 98.0704 159.63 98.0704 159.63Z" fill="black"/>
<path opacity="0.1" d="M83.0723 158.732C83.0723 158.732 85.6149 158.844 86.9989 159.482C88.3828 160.121 83.0723 158.732 83.0723 158.732Z" fill="black"/>
<path d="M73.8325 95.8231C73.8325 95.8231 74.243 103.639 74.0202 105.023C74.0202 105.023 74.9162 111.344 75.6644 112.951C76.4127 114.558 78.0219 116.58 78.0219 116.58L80.2292 101.064L79.7037 95.748L73.8325 95.8231Z" fill="#EFB7B9"/>
<path d="M97.0219 60.2158C101.793 60.2158 105.661 56.3479 105.661 51.5767C105.661 46.8055 101.793 42.9376 97.0219 42.9376C92.2507 42.9376 88.3828 46.8055 88.3828 51.5767C88.3828 56.3479 92.2507 60.2158 97.0219 60.2158Z" fill="#EFB7B9"/>
<path d="M92.5347 55.6134C92.5347 55.6134 89.8419 60.8889 87.149 63.3565C84.4562 65.8241 103.306 68.6296 103.754 68.6296C104.202 68.6296 100.388 57.4103 101.061 56.0564C101.734 54.7024 92.5347 55.6134 92.5347 55.6134Z" fill="#EFB7B9"/>
<path opacity="0.1" d="M111.61 115.654C111.187 115.977 110.72 116.238 110.223 116.43C106.785 117.776 103.043 119.646 100.5 118.9C97.9578 118.154 92.5722 118.9 92.5722 118.9C92.5722 118.9 81.7233 118.001 79.5585 118.524C78.5725 118.762 77.8067 118.752 77.3062 118.582C77.4038 117.679 77.4888 117.103 77.4888 117.103C77.4888 117.103 109.703 111.885 110.986 113.064C111.292 113.342 111.487 114.295 111.61 115.654Z" fill="black"/>
<path d="M113.965 110.669C113.965 110.669 113.667 114.41 110.223 115.757C106.78 117.103 103.043 118.972 100.501 118.227C97.9579 117.481 92.5722 118.227 92.5722 118.227C92.5722 118.227 81.7234 117.328 79.5586 117.851C77.3938 118.374 76.2651 117.704 76.9383 116.73C77.6115 115.757 77.539 112.541 77.539 111.194C77.539 109.848 76.7882 104.387 77.4614 103.414C78.1346 102.44 78.7327 98.7011 80.0791 98.1005C80.2813 98.0154 80.4618 97.8859 80.6073 97.7218C80.7529 97.5576 80.8597 97.3629 80.92 97.152C81.0313 96.7017 81.0253 96.2304 80.9025 95.7831C80.9025 95.7831 80.6748 95.5954 80.3619 95.3176C79.5686 94.6093 78.2272 93.2955 78.6576 92.865C79.2558 92.2644 78.6576 88.3753 78.6576 88.3753C78.6576 88.3753 77.2361 85.3846 77.7617 84.2635C78.2872 83.1423 73.1969 77.2311 73.1969 77.2311C73.1969 77.2311 73.1969 67.0604 79.3308 66.6099C79.3308 66.6099 83.6704 66.7601 84.1934 64.8155C84.7165 62.871 88.1576 61.7473 88.1576 61.7473L96.0134 63.4691C96.0134 63.4691 102.968 64.9707 104.242 64.0673C105.516 63.1638 106.494 65.2635 106.494 65.2635C106.494 65.2635 110.831 65.4887 111.279 66.3872C111.727 67.2856 109.86 76.0348 109.86 76.0348C109.86 76.0348 106.717 75.737 106.942 79.103C107.168 82.4691 105.731 86.7336 105.731 86.7336C105.731 86.7336 105.506 89.2012 105.656 89.7242C105.796 90.2072 105.361 92.0892 105.291 92.3795V92.417C105.291 92.417 104.978 93.6684 105.383 94.1138C105.421 94.1541 105.465 94.1879 105.513 94.2139C106.114 94.5117 107.015 97.4298 107.015 97.4298C107.482 97.9963 107.722 98.716 107.688 99.4494C107.616 100.648 108.064 103.489 110.008 105.135C111.953 106.782 113.965 110.669 113.965 110.669Z" fill="#A36468"/>
<path d="M80.6021 93.3455V93.6634L80.467 97.1671C80.467 97.1671 75.8647 97.54 73.3595 96.9168C70.8544 96.2936 71.908 93.5132 72.0081 92.9376C72.009 92.9301 72.009 92.9226 72.0081 92.9151C72.0807 92.3895 72.7589 88.0149 72.7589 87.3042C72.7589 86.5935 72.7589 83.6754 72.6463 82.329C72.5337 80.9826 73.1969 77.2311 73.1969 77.2311L73.6824 76.6355L78.9529 78.6551L80.6021 93.3455Z" fill="#A36468"/>
<path opacity="0.1" d="M80.5896 93.6708L80.4545 97.1745C80.4545 97.1745 75.8522 97.5474 73.347 96.9242C70.8419 96.3011 71.8955 93.5207 71.9956 92.9451L80.5896 93.6708Z" fill="black"/>
<path opacity="0.1" d="M80.92 97.1545C81.0312 96.7042 81.0252 96.2329 80.9024 95.7856C80.9024 95.7856 80.6747 95.5979 80.3619 95.3201C84.3235 94.767 100.013 92.6148 105.296 92.3795V92.4171C105.296 92.4171 104.983 93.6684 105.388 94.1138L80.92 97.1545Z" fill="black"/>
<path opacity="0.1" d="M105.886 99.8523C105.886 99.8523 106.86 105.358 103.231 107.295C103.228 107.305 105.288 104.575 105.886 99.8523Z" fill="black"/>
<path opacity="0.1" d="M82.1362 107.453C82.1362 107.453 90.8954 105.951 92.6097 107.118C94.324 108.284 82.1362 107.453 82.1362 107.453Z" fill="black"/>
<path opacity="0.1" d="M102.858 73.3795C102.858 73.3795 101.512 78.9153 102.52 80.1867C103.529 81.458 102.858 73.3795 102.858 73.3795Z" fill="black"/>
<path opacity="0.1" d="M77.4989 68.8549C77.4989 68.8549 78.7327 70.912 77.9844 73.0442C77.2361 75.1765 77.4989 68.8549 77.4989 68.8549Z" fill="black"/>
<path opacity="0.1" d="M74.9487 86.8838C74.9487 86.8838 76.5204 87.8173 75.9973 89.2763C75.4743 90.7353 74.9487 86.8838 74.9487 86.8838Z" fill="black"/>
<path opacity="0.1" d="M74.806 82.6193C74.806 82.6193 76.2626 83.4051 76.4503 84.5638C76.638 85.7225 74.806 82.6193 74.806 82.6193Z" fill="black"/>
<path opacity="0.1" d="M96.4237 127.351C96.4237 127.351 105.588 128.287 107.42 126.117C107.42 126.13 99.1541 127.764 96.4237 127.351Z" fill="black"/>
<path opacity="0.1" d="M80.6021 126.828C80.6021 126.828 90.4399 129.148 92.3845 127.314C92.3845 127.314 83.9306 127.949 80.6021 126.828Z" fill="black"/>
<path opacity="0.1" d="M97.1345 130.384C97.1345 130.384 101.249 130.384 103.156 130.497C105.063 130.61 97.1345 130.384 97.1345 130.384Z" fill="black"/>
<path opacity="0.1" d="M81.2754 132.136C81.2754 132.136 83.295 134.419 85.5774 134.008C87.8598 133.598 81.2754 132.136 81.2754 132.136Z" fill="black"/>
<path d="M85.242 38.7007C84.6089 39.6842 84.5863 40.8229 84.4212 41.914C84.0358 44.4642 82.7869 46.9343 80.8324 49.0165C79.038 50.9235 76.5779 52.6528 76.1124 54.9828C75.672 57.1951 77.166 59.3248 77.9494 61.4896C80.014 67.1681 77.131 73.1243 76.2901 78.9855C76.0574 80.6047 76.3377 82.6743 78.3323 83.2124C78.9554 83.3826 79.6687 83.3601 80.2293 83.6303C80.98 83.9907 81.2103 84.739 81.3479 85.4122C81.8499 87.8203 82.0233 90.2853 81.8635 92.7399C81.7734 94.1164 81.6733 95.7005 82.9746 96.6465C83.5653 97.0795 84.3611 97.2997 85.1294 97.5074C87.1791 98.0605 89.8293 98.5085 91.2108 97.2096C91.7914 96.6665 92.0091 95.9007 92.7324 95.4703C93.816 94.8271 95.3526 95.2626 96.7166 95.3301C99.517 95.4703 102.09 93.8286 103.193 91.849C104.297 89.8694 104.194 87.5945 103.794 85.4598C103.394 83.325 102.678 81.2053 102.628 79.038C102.61 78.2872 102.678 77.5239 103.108 76.8582C103.942 75.5694 105.881 74.9838 107.208 73.9702C109.693 72.0682 109.685 68.9524 108.782 66.3447C107.878 63.7369 106.257 61.2368 106.056 58.5415C105.967 57.8899 106.096 57.2271 106.424 56.657C106.78 56.1089 107.4 55.6985 107.926 55.2455C111.552 52.1823 111.124 47.152 108.126 43.7084C104.808 39.8919 89.7718 31.6708 85.242 38.7007Z" fill="#E3787D"/>
<g opacity="0.1">
<path opacity="0.1" d="M78.4098 63.847C78.6926 61.5721 78.6401 59.3172 77.8368 57.1024C77.4413 56.0163 76.8682 54.9376 76.4503 53.849C76.2415 54.2426 76.0898 54.6639 75.9998 55.1003C75.5594 57.3126 77.0534 59.4424 77.8368 61.6071C78.1004 62.3333 78.2924 63.0835 78.4098 63.847Z" fill="black"/>
<path opacity="0.1" d="M81.7508 88.3528C81.9103 85.8982 81.7377 83.4334 81.2378 81.0251C81.0976 80.3518 80.8674 79.6061 80.1166 79.2457C79.556 78.9754 78.8428 78.9954 78.2196 78.8277C77.8367 78.736 77.4799 78.5579 77.1763 78.3072C76.8727 78.0565 76.6304 77.7398 76.4678 77.3812C76.3527 77.9518 76.2526 78.5199 76.17 79.0905C75.9372 80.7097 76.2175 82.7794 78.2121 83.3175C78.8353 83.4851 79.5485 83.4626 80.1091 83.7329C80.8599 84.0933 81.0901 84.8416 81.2303 85.5148C81.4599 86.6317 81.6203 87.7617 81.7108 88.8983C81.7283 88.7131 81.7383 88.5329 81.7508 88.3528Z" fill="black"/>
<path opacity="0.1" d="M103.083 87.4643C101.977 89.4514 99.4044 91.0856 96.6039 90.9454C95.24 90.8754 93.7034 90.4449 92.6223 91.0856C91.899 91.5135 91.6788 92.2819 91.0982 92.8249C89.7167 94.1138 87.0664 93.6758 85.0168 93.1227C84.2485 92.9125 83.4552 92.6948 82.862 92.2618C82.2968 91.8461 81.9154 91.2269 81.7984 90.535C81.8134 91.3033 81.7984 92.0741 81.7509 92.8424C81.6608 94.2189 81.5607 95.803 82.862 96.7515C83.4552 97.182 84.2485 97.4022 85.0168 97.6099C87.0664 98.163 89.7167 98.611 91.0982 97.3121C91.6788 96.7691 91.899 96.0033 92.6223 95.5603C93.7034 94.9171 95.24 95.3526 96.6039 95.4201C99.4044 95.5603 101.977 93.9186 103.083 91.939C104.144 90.027 104.097 87.8647 103.726 85.8C103.587 86.3809 103.371 86.9406 103.083 87.4643Z" fill="black"/>
<path opacity="0.1" d="M107.823 50.8709C107.288 51.3214 106.667 51.7343 106.322 52.2824C105.994 52.8525 105.864 53.5153 105.954 54.1669C106.027 54.9858 106.2 55.7927 106.469 56.5694C106.886 56.1249 107.343 55.7195 107.833 55.3581C110.286 53.2885 110.881 50.3178 110.086 47.5449C109.666 48.8474 108.88 50.0019 107.823 50.8709Z" fill="black"/>
<path opacity="0.1" d="M107.095 69.583C105.771 70.5966 103.829 71.1847 102.998 72.4735C102.565 73.1392 102.498 73.9075 102.515 74.6508C102.546 75.5261 102.653 76.397 102.835 77.2536C102.883 77.1523 102.937 77.0545 102.998 76.9608C103.829 75.6719 105.771 75.0863 107.095 74.0727C109.365 72.3359 109.555 69.588 108.884 67.1379C108.544 68.1126 107.921 68.9639 107.095 69.583Z" fill="black"/>
</g>
<path d="M120.697 74.9137C120.697 74.9137 127.168 74.5783 127.729 71.848C128.29 69.1176 125.977 66.3422 125.412 66.0494C124.846 65.7566 118.745 61.1117 118.745 61.1117L108.909 54.8301C108.909 54.8301 104.197 41.3159 103.153 46.4888C102.11 51.6618 106.184 58.5315 106.184 58.5315C106.184 58.5315 111.83 62.1603 112.466 63.2439C113.101 64.3276 116.993 67.1705 116.993 67.1705L120.697 74.9137Z" fill="#EFB7B9"/>
<path d="M124.175 70.499C122.644 74.3906 120.659 75.9247 120.659 75.9247H119.555L109.853 76.0248L108.734 72.9691L110.306 66.3472L111.277 66.3872C111.277 66.3872 112.438 66.9853 113.146 66.9853C113.855 66.9853 115.243 66.9478 115.649 67.133C115.706 67.1607 115.769 67.1703 115.832 67.1605C116.199 67.123 116.582 66.5724 116.582 66.5724C116.582 66.5724 125.709 66.6099 124.175 70.499Z" fill="#A36468"/>
<path opacity="0.1" d="M124.175 70.499C122.644 74.3906 120.659 75.9247 120.659 75.9247H119.556C120.131 74.3831 121.345 71.2198 121.808 70.489C122.261 69.7983 118.197 68.079 115.819 67.1505C116.187 67.113 116.57 66.5624 116.57 66.5624C116.57 66.5624 125.709 66.6099 124.175 70.499Z" fill="black"/>
<path opacity="0.1" d="M22.7288 193.148C28.8352 193.148 33.7855 192.18 33.7855 190.986C33.7855 189.791 28.8352 188.823 22.7288 188.823C16.6225 188.823 11.6722 189.791 11.6722 190.986C11.6722 192.18 16.6225 193.148 22.7288 193.148Z" fill="#EB3838"/>
<path opacity="0.1" d="M207.037 178.297C211.485 178.297 215.091 177.592 215.091 176.723C215.091 175.854 211.485 175.149 207.037 175.149C202.59 175.149 198.984 175.854 198.984 176.723C198.984 177.592 202.59 178.297 207.037 178.297Z" fill="#EB3838"/>
<path opacity="0.1" d="M241.946 184.676C246.394 184.676 250 183.972 250 183.102C250 182.233 246.394 181.528 241.946 181.528C237.499 181.528 233.893 182.233 233.893 183.102C233.893 183.972 237.499 184.676 241.946 184.676Z" fill="#EB3838"/>
<path opacity="0.1" d="M187.892 197.815C192.34 197.815 195.946 197.11 195.946 196.241C195.946 195.372 192.34 194.667 187.892 194.667C183.445 194.667 179.839 195.372 179.839 196.241C179.839 197.11 183.445 197.815 187.892 197.815Z" fill="#EB3838"/>
<path d="M33.1773 130.963C33.1773 130.963 34.9892 133.333 32.3415 136.906C29.6937 140.48 27.5139 143.498 28.3998 145.728C28.3998 145.728 32.3915 139.089 35.6424 138.996C38.8933 138.903 36.7536 134.957 33.1773 130.963Z" fill="#EB3838"/>
<path opacity="0.1" d="M33.1774 130.963C33.3359 131.194 33.4606 131.447 33.5478 131.713C36.7186 135.44 38.4079 138.916 35.3597 139.003C32.5217 139.084 29.1156 144.161 28.2997 145.443C28.3259 145.542 28.3585 145.64 28.3973 145.736C28.3973 145.736 32.389 139.096 35.6399 139.003C38.8909 138.911 36.7536 134.957 33.1774 130.963Z" fill="black"/>
<path d="M36.5434 133.981C36.5434 134.814 36.4508 135.482 36.3356 135.482C36.2205 135.482 36.1254 134.807 36.1254 133.981C36.1254 133.155 36.2431 133.54 36.3582 133.54C36.4733 133.54 36.5434 133.137 36.5434 133.981Z" fill="#FFD037"/>
<path d="M37.6996 134.977C36.9688 135.375 36.3307 135.617 36.2756 135.515C36.2206 135.412 36.7761 135.014 37.4994 134.609C38.2227 134.203 37.9424 134.501 37.9999 134.609C38.0575 134.717 38.4304 134.576 37.6996 134.977Z" fill="#FFD037"/>
<path d="M23.6148 130.963C23.6148 130.963 21.8029 133.333 24.4507 136.906C27.0985 140.48 29.2782 143.498 28.3998 145.728C28.3998 145.728 24.3956 139.089 21.1422 138.996C17.8888 138.903 20.0385 134.957 23.6148 130.963Z" fill="#EB3838"/>
<path opacity="0.1" d="M23.6148 130.963C23.4563 131.194 23.3315 131.447 23.2444 131.713C20.0736 135.44 18.3843 138.916 21.4325 139.003C24.2705 139.084 27.6891 144.161 28.4924 145.443C28.466 145.542 28.4342 145.64 28.3973 145.736C28.3973 145.736 24.3931 139.096 21.1397 139.003C17.8863 138.911 20.0385 134.957 23.6148 130.963Z" fill="black"/>
<path d="M20.2488 133.981C20.2488 134.814 20.3414 135.482 20.4565 135.482C20.5716 135.482 20.6667 134.807 20.6667 133.981C20.6667 133.155 20.5491 133.54 20.434 133.54C20.3189 133.54 20.2488 133.137 20.2488 133.981Z" fill="#FFD037"/>
<path d="M19.0926 134.977C19.8258 135.375 20.4615 135.617 20.5191 135.515C20.5766 135.412 20.0185 135.014 19.2928 134.609C18.567 134.203 18.8498 134.501 18.7923 134.609C18.7347 134.717 18.3618 134.576 19.0926 134.977Z" fill="#FFD037"/>
<path opacity="0.1" d="M28.3948 163.842C38.8509 163.842 47.3272 162.541 47.3272 160.937C47.3272 159.332 38.8509 158.031 28.3948 158.031C17.9388 158.031 9.46246 159.332 9.46246 160.937C9.46246 162.541 17.9388 163.842 28.3948 163.842Z" fill="#EB3838"/>
<path d="M38.1401 142.537L38.05 143.288L37.9223 144.332L37.8698 144.767L37.7421 145.813L37.6871 146.249L37.5594 147.292L36.1129 159.165C35.9828 160.226 34.251 161.052 32.1588 161.052H24.6459C22.5537 161.052 20.8244 160.226 20.6942 159.165L19.2452 147.29L19.1176 146.246L19.065 145.811L18.9349 144.764L18.8823 144.329L18.7547 143.285L18.6646 142.535C18.592 141.934 19.528 141.428 20.7117 141.428H36.1079C37.2766 141.431 38.2151 141.936 38.1401 142.537Z" fill="#65617D"/>
<path d="M38.0475 143.275L37.9223 144.321H18.8673L18.7422 143.275H38.0475Z" fill="#9D9CB5"/>
<path d="M37.8673 144.757L37.7421 145.801H19.05L18.9224 144.757H37.8673Z" fill="#9D9CB5"/>
<path d="M37.687 146.236L37.5594 147.28H19.2302L19.1025 146.236H37.687Z" fill="#9D9CB5"/>
<path opacity="0.1" d="M45.0448 39.046C49.3986 39.046 52.928 35.5165 52.928 31.1627C52.928 26.8089 49.3986 23.2794 45.0448 23.2794C40.691 23.2794 37.1615 26.8089 37.1615 31.1627C37.1615 35.5165 40.691 39.046 45.0448 39.046Z" fill="#EB3838"/>
<path opacity="0.1" d="M28.5275 17.2732C31.2227 17.2732 33.4076 15.0883 33.4076 12.3931C33.4076 9.69785 31.2227 7.51294 28.5275 7.51294C25.8322 7.51294 23.6473 9.69785 23.6473 12.3931C23.6473 15.0883 25.8322 17.2732 28.5275 17.2732Z" fill="#EB3838"/>
<path opacity="0.1" d="M3.00315 26.2826C4.66175 26.2826 6.00631 24.938 6.00631 23.2794C6.00631 21.6208 4.66175 20.2762 3.00315 20.2762C1.34456 20.2762 0 21.6208 0 23.2794C0 24.938 1.34456 26.2826 3.00315 26.2826Z" fill="#EB3838"/>
</g>
<defs>
<linearGradient id="paint0_linear" x1="99.7598" y1="206.319" x2="99.7598" y2="34.6389" gradientUnits="userSpaceOnUse">
<stop stop-color="#808080" stop-opacity="0.25"/>
<stop offset="0.54" stop-color="#808080" stop-opacity="0.12"/>
<stop offset="1" stop-color="#808080" stop-opacity="0.1"/>
</linearGradient>
<clipPath id="clip0">
<rect width="250" height="208.717" fill="white"/>
</clipPath>
</defs>
</svg>

        <div>

                <p style="" class="bagline">Your Whishlist is Empty</p>
                <p style="" class="bagsubline">Looks like you haven’t made your choice yet.</p>
                <div class="d-flex align-items-center justify-content-center mt-4">
                  <router-link  to='/' style="text-decoration:none;color:#fff" class="backbtn">Back to Home</router-link>
                </div>
              </div>



        </div>
      </div>
    </div>
  </div>

</div>



<div v-if='cartscomp.length>0' class="pt-md-4 pb-md-5   pb-3  headerwrapper2  d-block   bagmobbg   "  style="min-height:calc(100vh - 200px)">
  <div class="container  pads " style="">
  <div class="   ">



 
  <div class="container" style="padding:0px;margin:0px; ">
    <div class="row" style="padding:0px;margin:0px; ">
      <div class="col-md-8 mobcontainer" style="padding:0px;padding-right:10px">

        <div v-if="tab=='bag'" >
          
 



<p style=""    class="mt-md-5 mb-md-5 mb-3 mt-md-3 mt-0 shopbag">Whishlist</p>



 <div class="inputboxui  d-md-none d-none  justify-content-between  " style="background:#fff!important;border:none!important;padding:0px;width:100%;max-width:100%;margin-bottom: 30px;">
  


  <div class="d-flex align-items-center  " v-on:click="tab='bag'" style="cursor:pointer">
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">1</p>
    </div>
   </div> 


  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='address' || tab=='paymentmode' "></div>
  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='bag'"></div>



   <div class="d-flex align-items-center  " v-if="tab=='address' || tab=='paymentmode'" style="cursor:pointer"  v-on:click="tab='address'">
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">2</p>
    </div>
   </div> 




   <div class="d-flex align-items-center  " v-if="tab=='bag'">
    <div style="width:40px;height:40px;background: #fff;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700">2</p>
    </div>
   </div> 




    <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='paymentmode'" ></div>
  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='address' || tab=='bag'"></div>



   <div class="d-flex align-items-center  " v-if="tab=='paymentmode'" style="cursor:pointer"   v-on:click="tab='paymentmode'" >
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">3</p>
    </div>
   </div> 



   <div class="d-flex align-items-center  " v-if="tab=='address' || tab=='bag'">
    <div style="width:40px;height:40px;background: #fff;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700;font-weight:700">3</p>
    </div>
   </div> 




 
</div>



 <div style="" class="cartborder" >

<div class="   d-flex  justify-content-between paditemslen  " style=" ">
  
  <p class="categorytextcat   itemslength" style=""  >{{rendercartlength}} Items</p>
 
 
</div>

<template v-for='(itm,index) in cartscomp'>




        <div class=" cartpad " style="">

          <div class="d-flex align-items-start" > 
            <div style="" class="imgitmwrap">
              <img :src="itm.imageurl" style="width:100%" class="img-fluid">
            </div>
            <div style=""  class="flexpad padtop">
              <div class=" ">
                <div>
                  



 <p style="width:100%" class="itemcartname" v-if='itm.varientbox'>{{itm.name}} </p>
                                  <p style=" " class="itemcartname" v-else>{{itm.name}}</p>
 
 
                </div>
                               




                                  <div>

 

<div class="d-md-flex d-none align-items-center ">

        <div v-on:click='setroute(itm)'   class="d-flex align-items-center " style="background:rgb(236 235 244 / 40%);padding:11px 25px;border-radius:5px;margin-top:24px;cursor:pointer;margin-right:15px">

          
 <p  style=" font-weight: 500;
font-size: 14px;
margin-left:8px;
  
color: #696979"  class="d-md-block d-none" >View Product</p>

</div>


            <div v-on:click='removeitem(itm)'   class="d-flex align-items-center " style="background:rgb(236 235 244 / 40%);padding:11px 25px;border-radius:5px;margin-top:24px;cursor:pointer">

              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM10.7673 11.962L8.00533 9.22733L5.26067 12L4.03867 10.778L6.77467 8.00667L4 5.26067L5.222 4.03867L7.992 6.77333L10.7293 4L11.962 5.23267L9.22867 7.99333L12 10.7293L10.7673 11.962Z" fill="#696979"/>
</svg>
 <p  style=" font-weight: 500;
font-size: 14px;
margin-left:8px;
  
color: #696979"  class="d-md-block d-none" >Remove</p>

</div>
            </div>
          


                                  </div>
               

              </div>


             


 





            </div>


          </div> 



        <div v-on:click='setroute(itm)'   class="d-md-none d-flex align-items-center justify-content-center " style="background:rgb(236 235 244 / 87%);;padding:11px 25px;border-radius:5px;margin-top:10px;cursor:pointer">

          
 <p  style=" font-weight: 500;
font-size: 14px;
margin-left:8px;
  
color: #696979"   >View Product</p>

</div>


     <div v-on:click='removeitem(itm)'   class="d-md-none d-flex align-items-center justify-content-center " style="background:rgb(236 235 244 / 87%);;padding:11px 25px;border-radius:5px;margin-top:5px;cursor:pointer">

              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM10.7673 11.962L8.00533 9.22733L5.26067 12L4.03867 10.778L6.77467 8.00667L4 5.26067L5.222 4.03867L7.992 6.77333L10.7293 4L11.962 5.23267L9.22867 7.99333L12 10.7293L10.7673 11.962Z" fill="#696979"/>
</svg>
 <p  style=" font-weight: 500;
font-size: 14px;
margin-left:8px;
  
color: #696979"  class=" " >Remove</p>

</div>





 
        </div>

<div  v-if='index!=cartscomp.length-1' style="" class="linecart">
     <div style="opacity: 0.5;
border-bottom: 1px solid #E7E7F7;"></div>
</div>
       
</template>

</div>




                </div>








        <div v-if="tab=='paymentmode'">
          

          {{paymentmodes}}
<div class=" d-none  justify-content-between  mb-md-4 mb-3 mt-md-3 mt-0  ">
  
  <p class="categorytextcat  "   >Choose Payment Mode</p>
 
</div>
 

 

 

<div class="d-flex align-items-center mt-md-5 mb-md-5 mb-3 mt-md-3 mt-0 m17" >
  
  <svg width="21"     v-on:click="tab='address'"   height="14" viewBox="0 0 21 14" style='cursor:pointer' fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.363604 6.3636C0.012132 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987511 7.36396 0.636039C7.01249 0.284567 6.44264 0.284567 6.09117 0.636039L0.363604 6.3636ZM1 7.9H21V6.1H1V7.9Z" fill="#0B0A23"/>
</svg>
<p  class="shopbag" style="margin-left:20px;margin-top:0px!important" >Choose Payment Mode
</p>


</div>


 
 <div class="inputboxui  d-md-none d-flex  justify-content-between  " style="background:#fff!important;border:none!important;padding:0px;width:100%;max-width:100%;margin-bottom: 30px;">
  


  <div class="d-flex align-items-center  " v-on:click="tab='bag'" style="cursor:pointer">
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">1</p>
    </div>
   </div> 


  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='address' || tab=='paymentmode' "></div>
  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='bag'"></div>



   <div class="d-flex align-items-center  " v-if="tab=='address' || tab=='paymentmode'" style="cursor:pointer"  v-on:click="tab='address'">
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">2</p>
    </div>
   </div> 




   <div class="d-flex align-items-center  " v-if="tab=='bag'">
    <div style="width:40px;height:40px;background: #fff;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700">2</p>
    </div>
   </div> 




    <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='paymentmode'" ></div>
  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='address' || tab=='bag'"></div>



   <div class="d-flex align-items-center  " v-if="tab=='paymentmode'" style="cursor:pointer"   v-on:click="tab='paymentmode'" >
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">3</p>
    </div>
   </div> 



   <div class="d-flex align-items-center  " v-if="tab=='address' || tab=='bag'">
    <div style="width:40px;height:40px;background: #fff;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700;font-weight:700">3</p>
    </div>
   </div> 




 
</div>




 


 <div style="" class="cartborder cartbs" >

<div class="   d-flex  justify-content-between paditemslen  " style=" ">
  
  <p class="categorytextcat   itemslength" style=""  >{{rendercartlength}} Items</p>
  <p class="categorytextcat  "  style="font-family: 'Montserrat', sans-serif;font-size:14px;font-weight:700" ><span style="" class="totaltext">Total: </span> <span  class="totalvals"> ₹ {{totalvalues}}</span></p>
 
</div>


 








<div class="container"   style=" border-radius:4px;padding:0px" >
  <div class="row" style="padding:0px;margin:0px">

 
    <div class="col-md-12" style="padding:0px;margin:0px">
      <div  >
        
        <div style="padding:31px 23px;cursor:pointer"  v-on:click="paymenttab='cash'" v-if= "info.paymentmethods.includes('COD')">

 
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              
                            <div v-if="paymenttab=='cash'"   style="width:22px;height:22px;border-radius:30px;border:1px solid rgb(246 74 84 / 90%);margin-right: 10px;" class="d-flex align-items-center justify-content-center">
                              <div style="width:14px;height:14px;border-radius:30px;background:rgb(246 74 84 / 90%)"></div>
                            </div>

                              <div v-else style="width:22px;height:22px;border-radius:30px;border:1px solid rgba(166, 166, 192, 0.6);background:background:rgba(255,255,255,0.6);margin-right: 10px;" class="d-flex align-items-center justify-content-center">
                             
                            </div>

                            <p style="font-weight: 500;
font-size: 16px;
 


color: #0B0A23;">Cash on Delivery</p>


            </div>

            <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 7C12.344 7 11 8.344 11 10C11 11.656 12.344 13 14 13C15.656 13 17 11.656 17 10C17 8.344 15.656 7 14 7ZM14.15 11.484V11.799H13.85V11.5C13.539 11.495 13.218 11.421 12.951 11.283L13.086 10.79C13.373 10.9 13.755 11.019 14.054 10.952C14.399 10.874 14.469 10.519 14.088 10.348C13.809 10.219 12.955 10.106 12.955 9.375C12.955 8.966 13.268 8.6 13.85 8.52V8.201H14.151V8.506C14.368 8.512 14.612 8.549 14.883 8.632L14.775 9.125C14.545 9.045 14.29 8.971 14.042 8.986C13.596 9.012 13.556 9.399 13.868 9.561C14.382 9.803 15.05 9.981 15.05 10.624C15.051 11.14 14.647 11.415 14.15 11.484ZM4 4V16H24V4H4ZM22 14H6V6H22V14ZM21 2H2V13H0V0H21V2Z" fill="rgba(11, 10, 35, 0.6)"/>
</svg>

            
          </div>





     
        </div>






<div   style="padding: 0px 8px;" v-if='info.paymentmethods.length==2'><div   style="opacity: 0.5; border-bottom: 1px solid rgb(231, 231, 247);"></div></div>



            <div style="padding:31px 23px;cursor:pointer"   v-on:click="paymenttab='online'" v-if="   info.paymentmethods.includes('ONLINE')">
 

       

          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              
                            <div v-if="paymenttab=='online'"   style="width:22px;height:22px;border-radius:30px;border:1px solid rgb(246 74 84 / 90%);margin-right: 10px;" class="d-flex align-items-center justify-content-center">
                              <div style="width:14px;height:14px;border-radius:30px;background:rgb(246 74 84 / 90%)"></div>
                            </div>

                              <div v-else style="width:22px;height:22px;border-radius:30px;border:1px solid rgba(166, 166, 192, 0.6);background:background:rgba(255,255,255,0.6);margin-right: 10px;" class="d-flex align-items-center justify-content-center">
                             
                            </div>

                            <p style="font-weight: 500;
font-size: 16px;
 


color: #0B0A23;">Online Payment</p>


            </div>

       <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 0H2C0.896 0 0 0.896 0 2V14C0 15.104 0.896 16 2 16H22C23.104 16 24 15.104 24 14V2C24 0.896 23.104 0 22 0ZM3 5.78C3 5.349 3.349 5 3.78 5H4.208V6.125H3V5.78ZM3 6.544H4.208V7.512H3V6.544ZM3 7.932H4.208V9H3.78C3.349 9 3 8.651 3 8.22V7.932ZM6 13H3V12H6V13ZM7 8.22C7 8.651 6.651 9 6.22 9H5.791V7.932H7V8.22ZM7 7.512H5.791V6.544H7V7.512ZM7 6.125H5.371V9H4.628V5H6.22C6.651 5 7 5.349 7 5.78V6.125ZM11 13H8V12H11V13ZM12 6.5C12 5.119 13.119 4 14.5 4C14.984 4 15.437 4.138 15.82 4.377C15.289 4.929 14.963 5.677 14.963 6.5C14.963 7.324 15.29 8.071 15.82 8.623C15.437 8.862 14.984 9 14.5 9C13.119 9 12 7.881 12 6.5ZM16 13H13V12H16V13ZM21 13H18V12H21V13ZM18.5 9C17.12 9 16 7.881 16 6.5C16 5.119 17.12 4 18.5 4C19.881 4 21 5.119 21 6.5C21 7.881 19.881 9 18.5 9Z" fill="rgba(11, 10, 35, 0.6)"/>
</svg>


            
          </div>



 
        </div>








       
      </div>
    </div>

  </div>
</div>
</div>
 

                </div>





        <div v-if="tab=='address'">
          




<div class=" d-none  justify-content-between  mb-md-4 mb-3 mt-md-3 mt-0  ">
  
  <p class="categorytextcat  "   >Select a delivery address</p>
 
</div> 




<div class="d-flex align-items-center mt-md-5 mb-md-5 mb-3 mt-md-3 mt-0 m17" >
  
  <svg width="21"  v-on:click="tab='bag'" height="14" viewBox="0 0 21 14" style='cursor:pointer' fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.363604 6.3636C0.012132 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987511 7.36396 0.636039C7.01249 0.284567 6.44264 0.284567 6.09117 0.636039L0.363604 6.3636ZM1 7.9H21V6.1H1V7.9Z" fill="#0B0A23"/>
</svg>
<p  class="shopbag" style="margin-left:20px;margin-top:0px!important" >Select Address
</p>


</div>


 
 <div class="inputboxui  d-md-none d-flex  justify-content-between  " style="background:#fff!important;border:none!important;padding:0px;width:100%;max-width:100%;margin-bottom: 30px;">
  


  <div class="d-flex align-items-center  " v-on:click="tab='bag'" style="cursor:pointer">
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">1</p>
    </div>
   </div> 


  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='address' || tab=='paymentmode' "></div>
  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='bag'"></div>



   <div class="d-flex align-items-center  " v-if="tab=='address' || tab=='paymentmode'" style="cursor:pointer"  v-on:click="tab='address'">
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">2</p>
    </div>
   </div> 




   <div class="d-flex align-items-center  " v-if="tab=='bag'">
    <div style="width:40px;height:40px;background: #fff;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700">2</p>
    </div>
   </div> 




    <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='paymentmode'" ></div>
  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='address' || tab=='bag'"></div>



   <div class="d-flex align-items-center  " v-if="tab=='paymentmode'" style="cursor:pointer"   v-on:click="tab='paymentmode'" >
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">3</p>
    </div>
   </div> 



   <div class="d-flex align-items-center  " v-if="tab=='address' || tab=='bag'">
    <div style="width:40px;height:40px;background: #fff;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700;font-weight:700">3</p>
    </div>
   </div> 




 
</div>


 


 <div style="" class="cartborder" >

<div class="   d-md-flex d-none  justify-content-between paditemslen  " style=" ">
  
  <p class="categorytextcat   itemslength" style=""  >{{rendercartlength}} Items</p>
  <p class="categorytextcat  "  style="font-family: 'Montserrat', sans-serif;font-size:14px;font-weight:700" ><span style="" class="totaltext">Total: </span> <span  class="totalvals"> ₹ {{totalvalues}}</span></p>
 
</div>






<div class="container" style="padding:0px;margin:0px">
  <div class="row cartpad3 mt-md-0 mt-3" style="">
    


                  <template v-for='(itm,index) in address'>
                    
 
                  <div v-if='!(index % 2 == 0)' class="col-md-6 mb-md-4 mb-3" style="padding:0px;margin:0px"  >
 
 
                    <div style="padding-left:13px;"  class="padlr">

                      <div style="border:1px solid rgba(231, 231, 247, 0.5);border-radius:5px;padding:20px;cursor:pointer;display:flex;align-items-start;background:rgb(239 239 245 / 45%)"  v-on:click='selectaddress(itm)'> 
                            
                          
     
                            <div v-if='itm.selected' style="width:22px;height:22px;border-radius:30px;border:1px solid rgb(246 74 84 / 90%);margin-top: 2px;" class="d-flex align-items-center justify-content-center">
                              <div style="width:14px;height:14px;border-radius:30px;background:rgb(246 74 84 / 90%)"></div>
                            </div>

                              <div v-else style="width:22px;height:22px;border-radius:30px;border:1px solid rgba(166, 166, 192, 0.6);background:background:rgba(255,255,255,0.6);margin-top: 2px;" class="d-flex align-items-center justify-content-center">
                             
                            </div>
                            
                            <div style="flex:1;padding-left:13px">
                              
                      
                           <p style="" class="addrname1">{{itm.name}}</p>

                            <p style=" " class="addrmobile1">Mobile:  {{itm.mobile}} </p>
                            <p style="" class="addraddr1">{{itm.address}}</p>
                            <p style="" class="addrcity1">{{itm.city}} . {{itm.pincode}}</p>



 <div class="d-flex align-items-center mt-md-3 mt-2">
                                <p style="" class="edit1" v-on:click='editaddress(itm)'>Edit</p>
                              <p style="
" class="del1" v-on:click='deleteaddress(itm)'>Delete</p>
                            </div>


 
                                  </div>


                      </div>
                        
                    </div>
              
                  </div>

                  <div v-else class="col-md-6 mb-md-4 mb-3" style="padding:0px;margin:0px"  >
                     <div style="padding-right:10px;" class="padlr" >

                      <div style="border:1px solid rgba(231, 231, 247, 0.5);border-radius:5px;padding:20px;cursor:pointer;font-family: 'Montserrat', sans-serif;display:flex;align-items-start;background:rgb(239 239 245 / 45%)"   v-on:click='selectaddress(itm)'> 
                              





     
                            <div v-if='itm.selected' style="width:22px;height:22px;border-radius:30px;border:1px solid rgb(246 74 84 / 90%);margin-top: 2px;" class="d-flex align-items-center justify-content-center">
                              <div style="width:14px;height:14px;border-radius:30px;background:rgb(246 74 84 / 90%)"></div>
                            </div>

                              <div v-else style="width:22px;height:22px;border-radius:30px;border:1px solid rgba(166, 166, 192, 0.6);background:rgba(255,255,255,0.6);margin-top: 2px;" class="d-flex align-items-center justify-content-center">
                             
                            </div>
                            
                            <div style="flex:1;padding-left:13px">
                                    <p style="" class="addrname1">{{itm.name}}</p>

                            <p style=" " class="addrmobile1">Mobile:  {{itm.mobile}} </p>
                            <p style="" class="addraddr1">{{itm.address}}</p>
                            <p style="" class="addrcity1">{{itm.city}} . {{itm.pincode}}</p>
                            <div class="d-flex align-items-center mt-md-3 mt-2">
                                <p style="" class="edit1" v-on:click='editaddress(itm)'>Edit</p>
                              <p style="
" class="del1" v-on:click='deleteaddress(itm)'>Delete</p>
                            </div>
                                  </div>
                             
                          


                      </div>
                        
                    </div>
              
                  </div>

                               </template>


                     


                      <div  v-if='!(address.length % 2 == 0)'     class="col-md-12 mb-4 mt-2   " style="padding:0px;margin:0px;"  >
                     <div style="padding-left:0px;height:100%">

                      <div style="border:1px solid #EB3838;border-radius:5px;padding:13px;cursor:pointer;font-family: 'Montserrat', sans-serif;height:100%" class="d-flex align-items-center justify-content-center " v-on:click='addressbox '> 
                              
                            
                           
                            <div class="d-flex align-items-center justify-content-center " v>
                           
                             <p style="font-weight: 600;
font-size: 16px;
 

text-align: center;

color: #EB3838;" >Add Address</p>
                            </div>

                             
                          


                      </div>
                        
                    </div>
              
                  </div>
                    <div  v-else     class="col-md-12 mb-4 mt-2   " style="padding:0px;margin:0px;"  >
                     <div style="padding-right:0px;height:100%">

                      <div style="border:1px solid #EB3838;border-radius:5px;padding:13px;cursor:pointer;font-family: 'Montserrat', sans-serif;height:100%" class="d-flex align-items-center justify-content-center " v-on:click='addressbox'> 
                              
                            
                           
                            <div class="d-flex align-items-center justify-content-center ">
                         
                             <p style="font-weight: 600;
font-size: 16px;
 

text-align: center;

color: #EB3838;" >Add Address</p>
                            </div>

                             
                          


                      </div>
                        
                    </div>
              
                  </div>

  </div>
</div>

</div>




                </div>


      </div>





       <div class="col-md-4 mobcontainer d-none" style="padding:0px;padding-left:10px">
        <div class="   rightcashbox " >



              <div  v-if="!rendercoupondatas.confirmedcoupon  "class="d-flex align-items-center justify-content-between py-3 px-4 mb-md-0 mb-2 applyborder " style="">
                <div class="d-flex align-items-center">

                  <div style="width:34px;height:34px;border-radius:34px;border:1px solid #FFB13B" class="d-flex align-items-center justify-content-center">
                    <p style="font-weight: 800;
font-size: 16px;
  


color: #FFB13B;">%</p>
                  </div>
              


                     <p style="" class="applyc">Apply Coupon</p>
                </div>
                <div v-on:click='apply=true' class="applybtns" style=" 
">
                  Apply
                </div>
             
              </div>




  <div   v-if="rendercoupondatas.confirmedcoupon && tab=='bag' "  class="d-flex align-items-center justify-content-between py-3 px-4 mb-md-0 mb-2 applyborder " style="">
                <div class="d-flex align-items-center">

                  <div style="width:34px;height:34px;border-radius:34px;border:1px solid #FFB13B" class="d-flex align-items-center justify-content-center">
                    <p style="font-weight: 800;
font-size: 16px;
  


color: #FFB13B;">%</p>
                  </div>
              


                     <p style="" class="applyc">{{rendercoupondatas.confirmedcouponcode}}</p>
                </div>
                <div  v-on:click='removecoupon' class="removebtns" style=" 

">
                  Remove
                </div>
             
              </div>








<!--


                <div class= " py-3 px-4  mb-md-0 mb-2" v-if="rendercoupondatas.confirmedcoupon && tab=='bag' " style="border-bottom:1px solid rgba(217, 215, 234, 0.4);background:#fff">
                  <div>
                    
                  
                <div class="d-flex align-items-center">
                 
                    
                  <div style="width:28px;height:28px;border-radius:34px;border:1px solid #FFB13B" class="d-flex align-items-center justify-content-center">
                    <p style="font-weight: 800;font-size: 14px;color: #FFB13B;">%</p>
                  </div>
                  <p style="color: rgb(255, 177, 59);font-size: 14px;margin-left: 12px;font-weight: 500;">{{rendercoupondatas.confirmedcouponcode}}</p>
                  <i  class="bx bx-x"  v-on:click='removecoupon' style="color: rgb(11, 10, 35); font-size: 25px;cursor:pointer;margin-left:auto;opacity: 0.6;"></i>

               </div>
                   <p style="color: #9a9ba7;font-size: 15px;font-weight: 400;font-family: Nunito, sans-serif;" class="mt-1">Coupon code successfully applied!</p>


                   </div>
             
                
              </div>

-->


              <div class="p-4 marb"  style="background:#fff;">
                      <div class="d-flex justify-content-between">
      <span  class="itmtxt itmtotaltxt" style="
">Item Total</span>
      <span class="itmtxt itmtxt1 " style="" id="itmtot">₹{{totalitemvalues}}</span>
    </div>



 <div class="d-flex justify-content-between mt-3 " v-if='rendercoupondatas.confirmedcoupon'>

     <span  class="itmtxt itmtotaltxt" style="
">Discount</span>
      <span class="itmtxt itmtxt1 " style="color:#19b959!important" id="itmtot">-₹{{rendercoupondatas.discountamount}}</span>


      




    </div>



 <div class="d-flex justify-content-between mt-3 ">
          <span  class="itmtxt deltxt" style="
">Delivery Fee</span>

      <span class="itmtxt" style="font-size:17px!important;color:#19b959;font-family: 'Nunito', sans-serif;font-weight:700" v-if="renderdelivery=='Free'" id="delcharge" data-delcharge=39>{{renderdelivery}}</span>
       <span class="itmtxt" style="font-size:17px!important; font-family: 'Nunito', sans-serif;font-weight:700" v-else id="delcharge" data-delcharge=39>{{renderdelivery}}</span>




    </div>
     <p class="itmtxt mt-2"  style="font-family: 'Roboto', sans-serif!important;font-size:14px!important;color:#808080; " v-if="renderdelivery!='Free' &&   Number(info.freedeliveryabove)!=0" id="delcharge" data-delcharge=39>Free delivery above       <span class="itmtotal" style="font-size:15px;font-weight:400;margin-left:4px;    font-family: 'Montserrat', sans-serif;text-transform: none;">₹{{info.freedeliveryabove}}</span></p>




    <div style="border-top: 1px solid #D9D7EA;margin-top:30px;margin-bottom:10px" ></div>



 
     <div class="d-flex justify-content-between    padtop15 "  >
      <span class="itmtotal totaltextsx" style="">Total</span>
      <span  class="itmtotal" style="font-weight: 600;
font-size: 19px; 

text-align: right;

color: #0B0A23;"  id="totalpay">₹{{totalvalues}}</span>
    </div>
 
 


<div  class="d-md-none d-block">

 
              <div v-if='rendercoupondatas.confirmedcoupon'   style="padding:0px 0px;border-radius:4px; color:#19b959!important; ">

<div   style="border-top: 1px solid rgb(217 215 234 / 40%);margin-top: 12px;margin-bottom: 10px;margin-left: -23px;margin-right: -29px;"></div>
                <p   style="    font-weight: 500;
    font-size: 16px;
    text-align: left;" class="mt-3"  ><span style="font-family: 'Montserrat', sans-serif;">₹{{rendercoupondatas.discountamount}}</span> saved so far!</p>

                <p   v-if="renderdelivery!='Free'"  style="    font-weight: 500;
    font-size: 16px;
    text-align: left;"   class="mt-1" >Save <span style="font-family: 'Montserrat', sans-serif;">₹{{info.deliveryamount}}</span> on delivery fee. Add <span style="font-family: 'Montserrat', sans-serif;    font-weight: 500;
    font-size: 16px;
    text-align: left;">₹ {{renderabovevalue}}</span> more to bag</p>


              </div>
</div>




              </div>



<div style="padding:0px 20px" class="d-md-block d-none">

 
              <div v-if='rendercoupondatas.confirmedcoupon' style="padding:7px 0px;border-radius:4px; color:#19b959!important; ;margin-bottom:-8px">
                <p   style="font-weight:500;font-size:16px;text-align:left"  ><span style="font-family: 'Montserrat', sans-serif;">₹{{rendercoupondatas.discountamount}}</span> saved so far!</p>
                <p   v-if="renderdelivery!='Free'"  style="font-weight:500;font-size:16px;text-align:left"   class="mt-1" >Save <span style="font-family: 'Montserrat', sans-serif;">₹{{info.deliveryamount}}</span> on delivery fee. Add <span style="font-family: 'Montserrat', sans-serif;">₹ {{renderabovevalue}}</span> more to bag</p>
              </div>
</div>
<div style="padding:9px 20px;margin-bottom:30px " class="d-md-block d-none" v-if="tab=='bag' || tab=='address'  || tab=='paymentmode' " >



  <div v-if="tab=='bag'" style=""  class="seladdrs" v-on:click="tab='address'">
  Select Address
</div>

<div v-if="tab=='address'" style="background:#EB3838;text-align:center;padding:10px;border-radius:5px;color:#fff;font-size:18px;cursor:pointer;font-size: 16px;
font-weight:700;

color: #FFFFFF;" v-on:click="checklogin">
Continue
</div>


<div v-if="tab=='paymentmode' && paymenttab=='cash'"    v-on:click='placeorders'  style="background:#EB3838;text-align:center;padding:10px;border-radius:5px;color:#fff;font-size:18px;cursor:pointer;font-size: 16px;
font-weight:700;

color: #FFFFFF;"  >
Place Order
</div>


<div  v-if="tab=='paymentmode' && paymenttab=='online'"  >
  <div v-if='!payloader'  v-on:click='payonline'    style="background:#EB3838;text-align:center;padding:10px;border-radius:5px;color:#fff;font-size:18px;cursor:pointer;font-size: 16px;
font-weight:700;

color: #FFFFFF;"  >
Pay ₹{{totalvalues}}
</div>
   <div v-else  style="background:#EB3838;text-align:center;padding:0px;border-radius:5px;color:#fff;font-size:18px;cursor:pointer;font-size: 16px;
font-weight:700;

color: #FFFFFF;"   >
 
<img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" style="height:50px">
</div>

</div>




 

</div>






<div style="padding:13px 14px;;position:fixed;bottom:54px;left:0;right:0;background: #F6F6FA;
border-radius: 3px;" class="d-md-none d-flex justify-content-between"  >

  <div class="mr-5">
          <p  class="itmtotal" style="font-family: 'Nunito', sans-serif;font-weight:700;font-size:17px;color:#0B0A23;transform:translateY(2px)"  id="totalpay">₹ {{totalvalues}}</p>
          <p style="color:#EB3838;font-size:14px;font-weight:600;transform:translateY(-2px)">View Price Details</p>

  </div>

  <router-link to="/address" style='text-decoration:none'>
  <div  style="background:#EB3838;font-size:13px;font-weight:700;text-align:center;border-radius:5px;color:#fff; cursor:pointer;padding:12px 20px;flex:1"  >
  Select Address
</div>
</router-link>
 

</div>





        </div>
      </div>

    </div>
  </div>



 




 








 
 </div>

  </div>
  
</div>
 

 </div>
 


 

<div  v-else >



    <div  style="height:calc(100vh - 94px);background:#fff; " class="d-md-flex d-none align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>




    <div  style="height:calc(100vh - 54px);background:#fff; " class="d-md-none d-flex align-items-center justify-content-center">
   
   <div style="width:80px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>





 

      </div>




 
 



 














  


   
 


 <div style="background: #262626;" class="p-5 mt-5">
   
   <div class="container py-5">
     <div class="row justify-content-center">



      
       <div class="col-md-4"  >
         <div>
             
 


 <div style="margin-left:-8px">
       <img  src="./images/finallogo.png" class="img-fluid" style="position:relative;height:40px" >

 </div>
<p style="font-weight: 400;font-size: 15px;margin:15px 0px;color: #FFFFFF;line-height: 26px;font-weight:600;display:none">SAYRA APPARELS PVT LTD</p>
 
 <h2 style="color:#fff;font-weight:600;font-size:18px;margin-top:22px">Get in Touch</h2>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Monday - Saturday</p>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">9:00 AM to 6:00 PM</p>
<a href="tel:+918433408665" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">+91 8433408665</a>
<a href="mailto:support@sayra.in" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">support@sayra.in</a>
<div class="d-none align-items-center   mt-4">
  <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;margin-right:13px;min-width:30px;background:#fff;margin-left:0px">
      <i class='bx bxl-facebook' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-instagram' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-youtube' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-twitter' style="color:#1B1A31;font-size:20px"></i>
  </div>
</div>

         </div>
       </div>


       <div class="col-md-4 mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">Customer Help</h2>
           <div>
             <router-link  to='/termsconditions' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Terms & Condition</router-link>


              <router-link   to='/privacypolicy'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Privacy Policy</router-link>
               <router-link   to='/refundpolicy'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Refund Policy</router-link>
                <router-link  to='/shipping'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Shipping Policy</router-link>
              <router-link  to='/returnexchange'  style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Return & Exchange</router-link>

                       <router-link to="/about"    style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">About Us</router-link>
           </div>
         </div>
       </div>
      
       <div class="col-md-4  mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">My Account</h2>
           <div>
             <router-link to='/bag' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">View Cart</router-link>

              <a href="https://tracklite.in/c/sayraindia" style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Track My Order</a>

               <router-link to='/contact' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Contact Us</router-link>
            </div>
         </div>
       </div>
           


           
         </div>




       </div>

     </div>
 
 

 <div style="background: #262626;" class="p-5 mt-5 d-none">
   
   <div class="container py-5">
     <div class="row justify-content-center">
       <div class="col-md-4"  >
         <div>
             
 
 <div style="margin-left:-8px">
       <img  src="./images/finallogo.png" class="img-fluid" style="position:relative;height:40px" >

 </div>
<p style="font-weight: 400;font-size: 15px;margin:15px 0px;color: #FFFFFF;line-height: 26px;font-weight:600;display:none">SAYRA APPARELS PVT LTD</p>
<h2 style="color:#fff;font-weight:600;font-size:18px">Customer Help</h2>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px">Monday - Saturday</p>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px">9:00 AM to 6:00 PM</p>
<a href="tel:+918433408665" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px">+91 8433408665</a>
<a href="mailto:support@sayra.in" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px">support@sayra.in</a>
<div class="d-none align-items-center   mt-4">
  <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;margin-right:13px;min-width:30px;background:#fff;margin-left:0px">
      <i class='bx bxl-facebook' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-instagram' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-youtube' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-twitter' style="color:#1B1A31;font-size:20px"></i>
  </div>
</div>

         </div>
       </div>


       <div class="col-md-4 mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">Customer Help</h2>
           <div>
            <a href="https://firebasestorage.googleapis.com/v0/b/sayra-a4201.appspot.com/o/Terms%20%26%20condition%20.pdf?alt=media&token=c99b4120-31e8-408c-8f53-10ff6aae2588" target="_blank" style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Terms & Condition</a>
              <a  href="https://firebasestorage.googleapis.com/v0/b/sayra-a4201.appspot.com/o/PRIVACY%20POLICY.pdf?alt=media&token=3284ed97-a8d2-49a6-9a2c-a5ee8639319a" target="_blank"  style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Privacy Policy</a>
               <a  href="https://firebasestorage.googleapis.com/v0/b/sayra-a4201.appspot.com/o/REFUND%20POLICY.pdf?alt=media&token=297c57e9-ec32-4437-a64e-bba5f32d1f17" target="_blank"  style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Refund Policy</a>
                <a href="https://firebasestorage.googleapis.com/v0/b/sayra-a4201.appspot.com/o/SHIPPING%20POLICY.pdf?alt=media&token=31ead305-7abb-4248-95b0-65e1eb9c7a22" target="_blank"   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Shipping Policy</a>
                       <a href="https://firebasestorage.googleapis.com/v0/b/sayra-a4201.appspot.com/o/Return%26%20exchange.pdf?alt=media&token=bd2f66df-2fc9-4836-96d5-5a0e3b3b3d71" target="_blank"   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Return & Exchange</a>

                       <router-link to="/about"    style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">About Us</router-link>
           </div>
         </div>
       </div>
      
       <div class="col-md-4  mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">My Account</h2>
           <div>
               <router-link to='/bag' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">View Cart</router-link>

              <a href="https://tracklite.in/c/sayraindia" style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Track My Order</a>
               <a href="mailto:support@sayra.in" style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Help</a>
            </div>
         </div>
       </div>
           


           
         </div>




       </div>

     </div>
   
   



 
 
  </div>
</div>
</div>
</template>

<script>
 
  import firebase from 'firebase'
   var coderesult

 const fb = require('./firebaseconfig.js')
  import axios from 'axios'

export default {
  props: ['coupondatas','coupons','loadstatus','info','products','category','deals','addcart','test','carts','placestatus','placetext','oldaddrdes','orderplaced','theme','fav','categoryall','favall'],

  
  data () {

        return{ phone:'',
        sendotpclicked:false,
            otp:'',
            logintype:'send',
            customotp:90922,
            payloader:false,
            phonetext:'Phone number',
            otptext:'OTP',
            errs:false,
            disp:'none',
            otpdes:true,
             otpenterd:true,
       otpvalue:'',
            perrs:false,

            user:false,
            loginbox:false,



            user:false,
            pageno:1,
            addrnames:'',
            addrmobile:'',
            mobilenum:'',
            paymenttab:'',
            coupontext:'',
            confirmedcoupon:false,
            notavailable:false,
            totalwithoutc:0,
            discountamount:'',
            selectedaddress:{},
            minorderamount:'',
            confirmedcouponcode:'',
            addrpincode:'',
            addrcity:'',
            apply:false,
            deletebox:false,
            addraddress:'',
            emptydata:false,
            tab:'bag',
            addbox:false,
            orders:[],
            orderss:[],
            edit:false,
            docid:null,
            address:[],
            filterbox:false,
            filters:[
            {
              name:'All orders',
              selected:true
            },
            {
              name:'Active orders',
              selected:false,
            },
            {
              name:'Completed orders',
              selected:false,
            },
            {
              name:'Failed orders',
              selected:false,
            },
            ]


        }
     
    
  },
  created(){
 

      if(firebase.auth().currentUser){

console.log(firebase.auth().currentUser)

this.mobilenum=firebase.auth().currentUser.phoneNumber


var vm=this
 

 




  this.user=true
 }else{

    this.user=false
 }



   },
   computed:{


cartscomp(){




var datas=[]
console.log('this.categoryall')

console.log(this.categoryall)

for (const key in this.categoryall) {
 
  for(var i=0;i<this.categoryall[key].length;i++){

 
    if(this.fav.includes(this.categoryall[key][i].id)){
     // alert('1s')
      datas.push(this.categoryall[key][i])
    }else{
     // alert('s')
    }
  }
}

 console.log(this.fav)

 

return datas




 
},



    paymentmodes(){
      if(this.info.paymentmethods.length==2){

 
        this.paymenttab='online'

      }else{
 
          if(this.info.paymentmethods.includes('ONLINE')){
          this.paymenttab='online'
          }else{
             this.paymenttab='cash'
          }
         
      }
    },
 rendercartlength(){



 
 

        var datas=[]
console.log('this.categoryall')

console.log(this.categoryall)

for (const key in this.categoryall) {
 
  for(var i=0;i<this.categoryall[key].length;i++){

 
    if(this.fav.includes(this.categoryall[key][i].id)){
     // alert('1s')
      datas.push(this.categoryall[key][i])
    }else{
     // alert('s')
    }
  }
}

 console.log(this.fav)

 

return datas.length





    },
    rendercoupondatas(){
      return this.coupondatas
    },
    renderabovevalue(){


        return Number(this.info.freedeliveryabove)-Number(this.totalwithoutc)
    },
    renderdelivery(){

 let total=0;
 
for(let item of this.carts){

  total += item.price;
}

 

      if(this.info.deliverystatus){


        if(Number(this.info.freedeliveryabove)<total &&  Number(this.info.freedeliveryabove)!=0){
          

          return 'Free'

        }else{

          return '₹'+this.info.deliveryamount

        }

      }else{

         return 'Free'
      }




    },
totalvalues(){


  let total=0;
 
for(let item of this.carts){

  total += item.price;
}



      if(this.info.deliverystatus){



        if(Number(this.info.freedeliveryabove)<total &&  Number(this.info.freedeliveryabove)!=0){

           total=total+0
        
        }else{



  total=total+Number(this.info.deliveryamount)
             
        

        }

      }else{
           total=total+0
      }


if(this.rendercoupondatas.confirmedcoupon){

  if(total>=this.rendercoupondatas.minorderamount){

 total=total-Number(this.rendercoupondatas.discountamount)

  }else{


 /*
this.confirmedcouponcode=''
 
this.confirmedcoupon=false

 this.discountamount=''
this.minorderamount=''
*/
  this.$emit('removecoupon')

this.coupontext=''




  }

}
 
this.totalwithoutc=total


var price=total.toString()




  if(price.length==4){
 return price[0]+','+price.slice(1,price.length)
  }
  else if(price.length==5){
 return price.slice(0,2)+','+price.slice(2,price.length)
  }
  else{
     return price
  }







 
}
,

totalitemvalues(){


  let total=0;
 
for(let item of this.carts){

  total += item.price;
}


 



var price=total.toString()




  if(price.length==4){
 return price[0]+','+price.slice(1,price.length)
  }
  else if(price.length==5){
 return price.slice(0,2)+','+price.slice(2,price.length)
  }
  else{
     return price
  }







 
}

 
    

   },
   methods:{


setroute(itm){
  this.$router.push({ path: '/productsdetails/'+itm.category+'/'+itm.id })

},
checklogin(){
  if(firebase.auth().currentUser!=null){
 this.tab='paymentmode'
  }else{
   this.loginbox=true
  }
 
},

        closeloginbox(){
      this.loginbox=false
      this.logintype='send'
    },
  login(){

 
 


var vm=this
var randotp=Math.floor(100000 + Math.random() * 900000);
this.sendotpclicked=true
vm.customotp=randotp

   axios.get('https://www.fast2sms.com/dev/bulkV2?authorization=bVo7GRmXxBWqwS3AiIfEaNeKvU8hHrgQ2ZkuFcPlp45d1M6yOYp5em7qztEDaJBSQdZfRVX3vjxs6Lkw&sender_id=iSAYRA&message=132422&variables_values='+vm.customotp+'&route=dlt&numbers='+vm.phone).then(function (response) {
 if(response.data.message.includes('SMS sent successfully.')){
  vm.logintype='otp'


            console.log(response)
 vm.sendotpclicked=false
}else{
  alert(response.data.message)
}


 

 })
},
 subotp(value){
      this.otpenterd=true
      this.otpvalue=value
    },

subotps(value){
 
var vm=this;

var already=false

 
if(vm.customotp==vm.otpvalue){



fb.db.collection("client5").where("email", "==",'+91'+vm.phone+'@sayra.com' )
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {

          already=true
            console.log(doc.id, " => ", doc.data());
        });


        if(already){



          fb.auth.signInWithEmailAndPassword('+91'+vm.phone+'@sayra.com', '+91'+vm.phone,)
  .then((userCredential) => {
    // Signed in 
    var user = userCredential.user;

           
       
 vm.logintype='send'
 vm.loginbox=false
 
vm.$router.push({ path: '/account' })

       vm.phone=''



 
  })
   



        }else{

          fb.auth.createUserWithEmailAndPassword('+91'+vm.phone+'@sayra.com', '+91'+vm.phone,)
  .then((userCredential) => {
    // Signed in 
    var user = userCredential.user;

    user.updateProfile({
  displayName:'+91'+vm.phone
 })

           

           fb.db.collection("client5").doc(fb.auth.currentUser.uid).set({
            email:'+91'+vm.phone+'@sayra.com'
           })
       
 vm.logintype='send'
 vm.loginbox=false
 
 
       vm.phone=''



var address=[]

 
 fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').orderBy('date','desc').onSnapshot(querySnapshot=>{
 address=[]
 var i=0;
    querySnapshot.forEach((doc)=> {
      
 
 

      if(i==0){
            vm.selectedaddress={
              id:doc.id,
              ...doc.data(),selected:true
            }
          address.push({id:doc.id,...doc.data(),selected:true})
        }else{
            address.push({id:doc.id,...doc.data(),selected:false})
        }
        i++
    
        
    }) 
 
 

vm.address=[
...address
]

})


 
  })
   



        }
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });













}else{
  vm.perrs=true
      vm.otptext='Invalid Otp'
      vm.otpvalue=''
      console.log('errorr')
       console.log(error.message);
       vm.otpenterd=false
       setTimeout(()=>{
         vm.perrs=false
       },3000)

}
 
 
 
  

},

addressbox(){
      if(firebase.auth().currentUser){
        this.addbox=true
        }else{
this.loginbox=true
        }

},

removeitem(items){

 

if(fb.auth.currentUser!=null){


var x=this.favall.filter((itm)=>{

  return itm.id==items.id
})


 
fb.db.collection('client5').doc(fb.auth.currentUser.uid).collection('favourites').doc(x[0].ids).delete()



}

},

async payonline(){

 
var vm=this
 

 
this.payloader=true

 
 axios.post('https://us-central1-wl-shopping.cloudfunctions.net/sendOpen?email='+fb.auth.currentUser.phoneNumber+'@makeashop.in'+'&mobile='+fb.auth.currentUser.phoneNumber+'&amount='+vm.totalvalues+'&subid='+vm.info.bankdetails.sub_accounts_id).then((response)=>{

 
 
   


   Layer.checkout({

        token: response.data.id,
        accesskey: "970b5350-fc44-11eb-8494-7f31ad2e29b9",
        theme: {

        
            color: "#3d9080",
            error_color : "#ff2b2b"

      
          }
    },
    function(response) {

     



        if (response.status == "captured") {


                        this.payloader=false





 
 


  let total=0;
 var deliverystatus=''



 var pricing={
  

}

for(let item of vm.carts){

  total += item.price;
}



      if(vm.info.deliverystatus){



        if(Number(vm.info.freedeliveryabove)<total){

           total=total+0
           deliverystatus='Free'
        
        }else{


deliverystatus= Number(vm.info.deliveryamount)
  total=total+Number(vm.info.deliveryamount)
             
        

        }

      }else{
        deliverystatus='Free'
           total=total+0
      }




if(vm.rendercoupondatas.confirmedcoupon){


pricing={
  couponapplied:{
      
      ...vm.rendercoupondatas,
      status:true


  }
}

  if(total>=vm.rendercoupondatas.minorderamount){

 total=total-Number(vm.rendercoupondatas.discountamount)


  } 

}else{

pricing={
  couponapplied:{

      status:false


  }
}
}


 
  pricing={
    ...pricing,
  deliveryamount:deliverystatus,
  paymentmode:'online',
    

  total:total,

}

 

  vm.$emit('placeorder',[vm.selectedaddress,vm.carts,pricing])
 
 

 





           // response.payment_token_id
           // response.payment_id

        } else if (response.status == "created") {


        } else if (response.status == "pending") {


        } else if (response.status == "failed") {

 vm.payloader=true

        } else if (response.status == "cancelled") {


            vm.payloader=false
        }
    },
    function(err) {
        //integration errors
    }
);


  }).catch((error)=>{
     console.log(error)
  })
 


  
 
 

},



 renderper(price,offerprice){
       var x=(Number(price)-Number(offerprice))/Number(price)

var actprice=x*100
return Math.round(actprice)+'% OFF'
},

  placeorders(){


    
var vm=this
if(fb.auth.currentUser){
 


  let total=0;
 var deliverystatus=''



 var pricing={
  

}

for(let item of this.carts){

  total += item.price;
}



      if(this.info.deliverystatus){



        if(Number(this.info.freedeliveryabove)<total){

           total=total+0
           deliverystatus='Free'
        
        }else{


deliverystatus= Number(this.info.deliveryamount)
  total=total+Number(this.info.deliveryamount)
             
        

        }

      }else{
        deliverystatus='Free'
           total=total+0
      }




if(this.rendercoupondatas.confirmedcoupon){


pricing={
  couponapplied:{
      
      ...this.rendercoupondatas,
      status:true


  }
}

  if(total>=this.rendercoupondatas.minorderamount){

 total=total-Number(this.rendercoupondatas.discountamount)


  } 

}else{

pricing={
  couponapplied:{

      status:false


  }
}
}


 
  pricing={
    ...pricing,
  deliveryamount:deliverystatus,
      paymentmode:'cod',

  total:total,

}

 

  this.$emit('placeorder',[vm.selectedaddress,vm.carts,pricing])
 
 


}else{


 alert('ssss')

}
  

 },

    selectaddress(item){

  this.address=this.address.map((itm)=>{

        if(itm.id==item.id){
          return {
            ...itm,
            selected:true
          }
        }else{
          return {
            ...itm,
            selected:false
          }
        }
      })
        this.selectedaddress={
          ...item
        }
    },


    applycoupon(item){
 

 var x=this.totalitemvalues.split(',')
 var amount=''
 for(var i=0;i<x.length;i++){

amount=amount+x[i]

 }
 
if(Number(amount) >=item.minorderamount)
{



 


var couponlocal={

confirmedcouponcode:item.couponcode,
confirmedcoupon:true,
discountamount:item.discountamount,
minorderamount:item.minorderamount,
couponid:item.id

}



  this.$emit('setcoupon',couponlocal)




this.coupontext=''


this.apply=false

 
 



}else{
  alert('s')
}




    },
    removecoupon(){



  this.$emit('removecoupon')


 
this.coupontext=''

 
    },

    checkcoupon(){
 


var x=this.coupons.filter((itm)=>{

  return itm.couponcode.toLowerCase()==this.coupontext.toLowerCase()

})


if(x.length>0 ){
 


 var xs=this.totalitemvalues.split(',')
 var amount=''
 for(var i=0;i<xs.length;i++){

amount=amount+xs[i]

 }
 

 if(Number(amount)>=x[0].minorderamount)
{




 




var couponlocal={

confirmedcouponcode:x[0].couponcode,
confirmedcoupon:true,
discountamount:x[0].discountamount,
minorderamount:x[0].minorderamount,

}
  this.$emit('setcoupon',couponlocal)


this.coupontext=''
this.apply=false
 this.notavailable=false

}else{
  alert('s')
}



}else{

 
 this.notavailable=true
 
 

}

    },

add(item){



if(item.varientbox){
 



var items={
  
  ...item,
  
  vaientid:item.vaientid

}






 this.$emit('addcart',items)

}else{


 






 this.$emit('addcart',item)

}


 
  
 


         
    },
    sub(item){


 
if(item.varientbox){
  




var items={
  
  ...item,
  
  vaientid:item.vaientid

}






 this.$emit('subcart',items)

}else{


 






 this.$emit('subcart',item)

}

 
  }
  ,
async signout(){
  await firebase.auth().signOut()

  this.$router.push({ path: '/' })

},
    async finaldelete(){
         await fb.db.collection('shopusers').doc(firebase.auth().currentUser.uid).collection('address').doc(this.docid).delete()

         this.deletebox=false
    },
    deleteaddress(item){
 

        this.deletebox=true

        this.docid=item.id

 

 


    },
    editaddress(item){


var vm=this
         this.edit=true
        this.docid=item.id

 
  vm.addrnames=item.name
 
  vm.addrmobile=item.mobile
 vm.addrpincode=item.pincode
   vm.addrcity=item.city
 vm.addraddress=item.address

vm.addbox=true



    },
   async addaddress(){


var vm=this
    if(this.edit){
 
 


 await fb.db.collection('shopusers').doc(firebase.auth().currentUser.uid).collection('address').doc(vm.docid).update({

  name:vm.addrnames,
  mobile:vm.addrmobile,
  pincode:vm.addrpincode,
  city:vm.addrcity,
  address:vm.addraddress,
  date:new Date()

 })



 vm.addrnames=''
  vm.addrmobile=''
 vm.addrpincode=''
   vm.addrcity=''
 vm.addraddress=''

 vm.addbox=false
   this.edit=false
        this.docid=null




         }else{




      var vm=this
 

 

 await fb.db.collection('shopusers').doc(firebase.auth().currentUser.uid).collection('address').add({

  name:vm.addrnames,
  mobile:vm.addrmobile,
  pincode:vm.addrpincode,
  city:vm.addrcity,
  address:vm.addraddress,
  date:new Date()

 })



 vm.addrnames=''
  vm.addrmobile=''
 vm.addrpincode=''
   vm.addrcity=''
 vm.addraddress=''

 vm.addbox=false





    }
    },
    closeaddbox(){
      this.addbox=false

    },
    filterorder(item){


var y=this.filters.map((itms)=>{

  if(item.name==itms.name){
    return {
      ...itms,
      selected:true
    }
  }else{
     return {
      ...itms,
      selected:false
    }
  }
})
     

if(item.name=='All orders'){


 var x=[
 ...this.orderss
 ]

}
else if(item.name=='Completed orders'){

   var x=this.orderss.filter((itm)=>{

          return itm.status=='Delivered' 
 })
}
else if(item.name=='Active orders'){

   var x=this.orderss.filter((itm)=>{

          return itm.status=='Accepted'|| itm.status=='pending' || itm.status=='Shipped'

 })
}
else{
 var x=this.orderss.filter((itm)=>{

          return itm.status=='Rejected'|| itm.status=='Cancelled' || itm.status=='Not Delivered'

 })

}
 
 
 
      this.orders=[
      ...x
      ]
      this.filters=[
      ...y
      ]

      this.filterbox=false

    },

  account(){


     if(firebase.auth().currentUser){

//alert('yes')


this.$router.push({ path: '/account' })

 }else{
this.loginbox=true
 }
    },
    
     renderdate(timestamp){

      var date=timestamp.toDate();
      var stringdate=date.getDate()+'/'+date.getMonth()+'/'+date.getFullYear()
      var today=new Date()
      var stringtoday=today.getDate()+'/'+today.getMonth()+'/'+today.getFullYear()
      var yesterday=new Date()
      yesterday.setDate(yesterday.getDate() - 1);


      var stringyesterdayday=yesterday.getDate()+'/'+yesterday.getMonth()+'/'+yesterday.getFullYear()
 
 

if(stringdate==stringtoday){
 
 return 'Today, '+ date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
 
}else if(stringyesterdayday==stringdate){

 
 return 'Yesterday, '+date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

   
}else{

return stringdate+', '+date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

}

     

    },

  
      logout(){
        var vm=this

        fb.auth.signOut().then(function() {
 
vm.user=false
vm.$router.push({ path: '/'})

}).catch(function(error) {
 
});
      }
   }


   
    
 
  
}
</script>
<style scoped >


</style>
 



// WEBPACK FOOTER //
// src/whishlist.vue